//// Babylon Render Engine 
const KonfigTracking = (() => {

  // ── KONFIGURATION ─────────────────────────────────────────
  const WP_URL  = 'https://dashboard.mirrored.pro/';
  const API_KEY = 'testkey';
  const KONFIG  = 'Konfigurator'; // ← pro Kunde anpassen
  const USER_ID = 6;            // ← WP User ID des Kunden

  // ── SESSION STATE ─────────────────────────────────────────
  const SESSION_ID    = 'sess-' + Math.random().toString(36).substr(2, 9);
  const SESSION_START = { time: null };
  let   _endFired     = false; // doppeltes Feuern verhindern

  // ── DEVICE ────────────────────────────────────────────────
  function getDevice() {
    const ua = navigator.userAgent;
    if (/iPhone|iPad|iPod/.test(ua)) return 'ios';
    if (/Android/.test(ua)) return 'android';
    return 'desktop';
  }

  // ── SEND ──────────────────────────────────────────────────
  function send(element_key, event_type, duration_ms = 0, cart_value = 0) {
    const payload = JSON.stringify({
      user_id:      USER_ID,
      konfigurator: KONFIG,
      element_key,
      event_type,
      duration_ms,
      cart_value,
      device:       getDevice(),
      page_url:     window.location.href,
      session_id:   SESSION_ID,
    });

    // fetch primär
    fetch(`${WP_URL}/wp-json/konfig/v1/track`, {
      method:  'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Konfig-Key': API_KEY,
      },
      body: payload,
    }).catch(() => {
      // Fallback: sendBeacon wenn fetch fehlschlägt
      navigator.sendBeacon(
        `${WP_URL}/wp-json/konfig/v1/track`,
        new Blob([payload], { type: 'application/json' })
      );
    });
  }

  // ── END SESSION ───────────────────────────────────────────
  function endSession() {
    // Doppeltes Feuern verhindern
    if (!SESSION_START.time || _endFired) return;
    _endFired = true;

    const duration_ms = Date.now() - SESSION_START.time;
    SESSION_START.time = null;

    const payload = JSON.stringify({
      user_id:      USER_ID,
      konfigurator: KONFIG,
      element_key:  'session:close',
      event_type:   'dwell',
      duration_ms:  duration_ms,
      cart_value:   0,
      device:       getDevice(),
      page_url:     window.location.href,
      session_id:   SESSION_ID,
    });

    // fetch primär
    fetch(`${WP_URL}/wp-json/konfig/v1/track`, {
      method:  'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Konfig-Key': API_KEY,
      },
      body: payload,
    }).catch(() => {
      // Fallback: sendBeacon
      navigator.sendBeacon(
        `${WP_URL}/wp-json/konfig/v1/track`,
        new Blob([payload], { type: 'application/json' })
      );
    });
  }

  // ── INIT ──────────────────────────────────────────────────
  function init() {
    SESSION_START.time = Date.now();
    _endFired          = false; // Reset falls init() erneut aufgerufen wird
    send('session:start', 'click');

    // Methode 1: Tab/Browser schließen, URL wechseln
    window.addEventListener('beforeunload', endSession, { once: true });

    // Methode 2: Tab wechseln, App minimieren (iOS zuverlässig)
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        endSession();
      }
    }, { once: true });
  }

  // ── TRACK CLICK ───────────────────────────────────────────
  function track(category, value, cartValue = 0) {
    const element_key = ['addcart','failedcart', 'ar:start', 'session:close'].includes(category)
      ? category
      : `${category}:${value}`;
    send(element_key, 'click', 0, cartValue);
  }

  // ── TRACK DWELL ───────────────────────────────────────────
  function trackDwell(category, value, startTime) {
    const ms = Date.now() - startTime;
    if (ms < 500) return; // unter 0.5s ignorieren
    send(`${category}:${value}`, 'dwell', ms);
  }

  // ── EXPORT ────────────────────────────────────────────────
  return { init, track, trackDwell, endSession };

})();



const canvas = document.getElementById("renderCanvas"); // Get the canvas element
      const engine = new BABYLON.Engine(canvas, true); // Generate the BABYLON 3D engine

      // Add your code here matching the playground format
      const createScene = function () {
        const scene = new BABYLON.Scene(engine);

        engine.setHardwareScalingLevel(1 / window.devicePixelRatio)
    

       var bikemesh;
        var manny = BABYLON.SceneLoader.ImportMesh("", "https://mirrored.pro/wp-content/uploads/cyclite/konfigurator/bike3.glb", "", scene, function(newMeshes){
           bikemesh= newMeshes[0];
         

          
        });
       
    
      
    
        const camera = new BABYLON.ArcRotateCamera("camera", -Math.PI / 2, Math.PI / 2.5, 15, new BABYLON.Vector3(0, 0, 0));
        camera.attachControl(canvas, true);
        camera.setPosition(new BABYLON.Vector3(-2.1360,0.6,0));
        camera.target = new BABYLON.Vector3(0,0.63,0);
        /*
        const light = new BABYLON.HemisphericLight("light", new BABYLON.Vector3(1, 1, 0));
        const light1 = new BABYLON.HemisphericLight("light", new BABYLON.Vector3(-1, 1, 0));
        */
  const light = new BABYLON.HemisphericLight("light", new BABYLON.Vector3(-2, -0.05, 0));
  light.intensity=1.6;


        const light1 = new BABYLON.HemisphericLight("light1", new BABYLON.Vector3(2, 0.8, 0));
 light1.intensity=2.3;

const forntallight = new BABYLON.PointLight("forntallight", new BABYLON.Vector3(0, 1, -1.5), scene);
forntallight.intensity=1;

const hecklight = new BABYLON.PointLight("hecklight", new BABYLON.Vector3(0, 1.3, 1.5), scene);
hecklight.intensity=1;

const linkslight = new BABYLON.PointLight("linkslight", new BABYLON.Vector3(2, 0.03, 0), scene);
linkslight.intensity=4;

scene.imageProcessingConfiguration.toneMappingEnabled = true;


        camera.wheelPrecision = 100;
        camera.lowerRadiusLimit=1;
        camera.upperRadiusLimit=1;
        camera.minZ = 0;


        setTimeout( () => {
camera.upperRadiusLimit=1.8;},1000);

   
        //scene.debugLayer.show();
        
        return scene;
      };

      
      

      function startRender(){
      const scene = createScene(); //Call the createScene function
      scene.clearColor =new BABYLON.Color4(0, 0, 0, 0);
      

      // Register a render loop to repeatedly render the scene
      engine.runRenderLoop(function () {
        scene.render();
      });

      // Watch for browser/canvas resize events
      window.addEventListener("resize", function () {
        engine.resize();
      });}

    
        //SADDLEBAG
 var saddleMesh;
        function renderSaddlebag(scene){        
          saddy = BABYLON.SceneLoader.ImportMesh("",  "https://mirrored.pro/wp-content/uploads/cyclite/konfigurator/SaddleBag02.glb", "", scene, function(newMeshes){
          saddleMesh= newMeshes[0];
          selectVariant(saddleMesh,color);
        });         
        }   
        function disposeSaddlebago(){
            saddleMesh.dispose();
        }
        function changeSaddlebag(val){
          selectVariant(saddleMesh, val)  
        }

         var saddleNanoMesh;
        function renderSaddlebagNano(scene){        
          saddy = BABYLON.SceneLoader.ImportMesh("",  "https://mirrored.pro/wp-content/uploads/cyclite/konfigurator/SaddleBagNANO.glb", "", scene, function(newMeshes){
          saddleNanoMesh= newMeshes[0];
          selectVariant(saddleNanoMesh,color);
        });         
        }   
        function disposeSaddlebagNano(){
            saddleNanoMesh.dispose();
        }
        function changeSaddlebagNano(val){
          selectVariant(saddleNanoMesh, val)  
        }

        //FrameBag
        var framebagMesh;
        function renderFramebag(scene){        
       framebag = BABYLON.SceneLoader.ImportMesh("", "https://mirrored.pro/wp-content/uploads/cyclite/konfigurator/FrameBag02.glb", "", scene, function(newMeshes){
          framebagMesh= newMeshes[0];
          selectVariant(framebagMesh, color);
        });         
        }   
        function disposeFramebag(){
            framebagMesh.dispose();
        }
        function changeFramebag(val){
          selectVariant(framebagMesh, val)  
        }

        //FrameBag Large
        var framebaglMesh;
        function renderFramebagl(scene){        
        framebagl = BABYLON.SceneLoader.ImportMesh("", "https://mirrored.pro/wp-content/uploads/cyclite/konfigurator/FrameBagL.glb", "", scene, function(newMeshes){
          framebaglMesh= newMeshes[0];
          selectVariant(framebaglMesh, color);
        });         
        }   
        function disposeFramebagl(){
            framebaglMesh.dispose();
        }
        function changeFramebagl(val){
          selectVariant(framebaglMesh, val)  
        }

   //FrameBag XT
        var framebagXTMesh;
        function renderFramebagXT(scene){        
       framebagXT = BABYLON.SceneLoader.ImportMesh("", "https://mirrored.pro/wp-content/uploads/cyclite/konfigurator/FrameBagXT.glb", "", scene, function(newMeshes){
          framebagXTMesh= newMeshes[0];
          selectVariant(framebagXTMesh, color);
        });         
        }   
        function disposeFramebagXT(){
            framebagXTMesh.dispose();
        }
        function changeFramebagXT(val){
          selectVariant(framebagXTMesh, val)  
        }

   //FrameBag Small
        var framebagSmallMesh;
        function renderFramebagSmall(scene){        
       framebagSmall = BABYLON.SceneLoader.ImportMesh("", "https://mirrored.pro/wp-content/uploads/cyclite/konfigurator/FrameBagS.glb", "", scene, function(newMeshes){
          framebagSmallMesh= newMeshes[0];
          selectVariant(framebagSmallMesh, color);
        });         
        }   
        function disposeFramebagSmall(){
            framebagSmallMesh.dispose();
        }
        function changeFramebagSmall(val){
          selectVariant(framebagSmallMesh, val)  
        }


        //TopTube
        var toptubeMesh;
        function renderToptube(scene){
          
               toptubel = BABYLON.SceneLoader.ImportMesh("", "https://mirrored.pro/wp-content/uploads/cyclite/konfigurator/TopTubeBag03.glb", "", scene, function(newMeshes){

          toptubeMesh= newMeshes[0];
          selectVariant(toptubeMesh, color);
        });         
        }   
        function disposeTopTube(){
          toptubeMesh.dispose();
        }
        function changeToptube(val){
          selectVariant(toptubeMesh, val)  
        }

          //TopTube Nano
        var toptubeNMesh;
        function renderToptubeN(scene){
          
               toptuben = BABYLON.SceneLoader.ImportMesh("", "https://mirrored.pro/wp-content/uploads/cyclite/konfigurator/TopTubeBagNANO.glb", "", scene, function(newMeshes){

          toptubeNMesh= newMeshes[0];
          selectVariant(toptubeNMesh, color);
        });         
        }   
        function disposeTopTubeN(){
          toptubeNMesh.dispose();
        }
        function changeToptubeN(val){
          selectVariant(toptubeNMesh, val)  
        }

          //TopTube Large
          var toptubelmesh;
          function renderToptubel(scene){        
                            toptubel = BABYLON.SceneLoader.ImportMesh("", "https://mirrored.pro/wp-content/uploads/cyclite/konfigurator/TopTubeBagL.glb", "", scene, function(newMeshes){


            toptubelmesh= newMeshes[0];
            selectVariant(toptubelmesh, color);
          });         
          }   
          function disposeToptubel(){
              toptubelmesh.dispose();
          }
          function changeToptubel(val){
            selectVariant(toptubelmesh, val)  
          }

        //Foodpouch
        var foodpouchMesh;
        function renderFoodpouch(scene){        
                          foodpouch = BABYLON.SceneLoader.ImportMesh("", "https://mirrored.pro/wp-content/uploads/cyclite/konfigurator/FoodPouchR.glb", "", scene, function(newMeshes){


          foodpouchMesh= newMeshes[0];
          selectVariant(foodpouchMesh, color);
        });         
        }   
        function disposeFoodpouch(){
          foodpouchMesh.dispose();
        }
        function changepouch(val){
          selectVariant(foodpouchMesh, val)  
        }

        //

        
        //Foodpouch
        var handlebarNanoMesh;
        function renderHBBN(scene){        
                          handlebarnano = BABYLON.SceneLoader.ImportMesh("", "https://mirrored.pro/wp-content/uploads/cyclite/konfigurator/HandleBarAeroBagNANO.glb", "", scene, function(newMeshes){


          handlebarNanoMesh= newMeshes[0];
          selectVariant(handlebarNanoMesh, color);
        });         
        }   
        function disposeHBBN(){
          handlebarNanoMesh.dispose();
        }
        function changeHBBN(val){
          selectVariant(handlebarNanoMesh, val)  
        }


        
        //Forkbag
        var forkbagMeshR;
        function renderForkbagR(scene){        
                          forkbagR = BABYLON.SceneLoader.ImportMesh("", "https://mirrored.pro/wp-content/uploads/cyclite/konfigurator/ForkBag01R.glb", "", scene, function(newMeshes){


          forkbagMeshR= newMeshes[0];
          selectVariant(forkbagMeshR, color);
        });         
        }   
        function disposeForkbagR(){
          forkbagMeshR.dispose();
        }
        function changeForkbagR(val){
          selectVariant(forkbagMeshR, val)  
        }

          var forkbagMeshL;
        function renderForkbagL(scene){        
                          forkbagR = BABYLON.SceneLoader.ImportMesh("", "https://mirrored.pro/wp-content/uploads/cyclite/konfigurator/ForkBag01L.glb", "", scene, function(newMeshes){


          forkbagMeshL= newMeshes[0];
          selectVariant(forkbagMeshL, color);
        });         
        }   
        function disposeForkbagL(){
          forkbagMeshL.dispose();
        }
        function changeForkbagL(val){
          selectVariant(forkbagMeshL, val)  
        }



          var foodpouchMeshL;
        function renderFoodpouchL(scene){        
                          foodpouchL = BABYLON.SceneLoader.ImportMesh("", "https://mirrored.pro/wp-content/uploads/cyclite/konfigurator/FoodPouchL.glb", "", scene, function(newMeshes){


          foodpouchMeshL= newMeshes[0];
          selectVariant(foodpouchMeshL, color);
        });         
        }   
        function disposeFoodpouchL(){
          foodpouchMeshL.dispose();
        }
        function changepouchL(val){
          selectVariant(foodpouchMeshL, val)  
        }
        

        //SaddleBagSmall
        var saddleSmallMesh;
        function renderSaddlebagS(scene){        
        saddyS = BABYLON.SceneLoader.ImportMesh("", "https://mirrored.pro/wp-content/uploads/cyclite/konfigurator/SaddleBagS.glb", "", scene, function(newMeshes){
          saddleSmallMesh= newMeshes[0];
          selectVariant(saddleSmallMesh, color);
        });         
        }   
        function disposeSaddlebagSmall(){
            saddleSmallMesh.dispose();
        }
        function changeSaddlebagSmall(val){
          selectVariant(saddleSmallMesh, val)  
        }
      
        //AERO
        var aeroMesh;
        function renderAero(scene){        
       saddy = BABYLON.SceneLoader.ImportMesh("", "https://mirrored.pro/wp-content/uploads/cyclite/konfigurator/HandleBarAeroBag02.glb", "", scene, function(newMeshes){
          aeroMesh= newMeshes[0];
          selectVariant(aeroMesh, color);
        });         
        }   
        function disposeAero(){
           

            if(!visAero && !visRoll){
                   aerorollMesh.dispose();
            }else{   aeroMesh.dispose();

            }
        }
        function changeAero(val){
          selectVariant(aeroMesh, val)  
        }

        // ROLLBAG
        var rollMesh;
        function renderRoll(scene){        
        roll = BABYLON.SceneLoader.ImportMesh("", "https://mirrored.pro/wp-content/uploads/cyclite/konfigurator/HandleBarRollBag02.glb","", scene, function(newMeshes){
          rollMesh= newMeshes[0];
          selectVariant(rollMesh, color);
        });         
        }   
        function disposeRoll(){
          
            if(!visAero && !visRoll){
                   aerorollMesh.dispose();
            }else{
            rollMesh.dispose();}
            }
        function changeRoll(val){
          selectVariant(rollMesh, val)  
        }
       

var aerorollMesh;
        function renderAeroRoll(scene){        
         saddy = BABYLON.SceneLoader.ImportMesh("", "https://mirrored.pro/wp-content/uploads/cyclite/konfigurator/Aeroroll.glb", "", scene, function(newMeshes){
          aerorollMesh= newMeshes[0];
           selectVariant(aerorollMesh, color);
        });         
        }   
        function disposeAeroRoll(){
            aerorollMesh.dispose();
        }
        function changeAeroRoll(val){
          selectVariant(aerorollMesh, val)  
        }

const canvasParent = document.getElementById('canvas-style');
const enlargeButton = document.getElementById('fullsize');

   

     let enlargeStatus = false;

    enlargeButton.onclick = function(e) {
        if (!enlargeStatus) {
              enlargeButton.style.bottom= "95%";
            if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        // Starte den Vollbild-Simulation Modus
        alert("Rotiere bitte dein Gerät");
              
              document.getElementById("renderCanvas").style.width="100vw";
              document.getElementById("renderCanvas").style.height="100vh";
              document.getElementById("renderCanvas").style.right="0%";
              document.getElementById("renderCanvas").style.top="0%";
              document.getElementById("renderCanvas").style.position="fixed";
              document.getElementById("renderCanvas").style.background="white";
              document.getElementById("renderCanvas").style.zIndex="9998";

              document.getElementById("fullsize").style.position="fixed";
               document.getElementById("fullsize").style.bottom="90% ";
              document.getElementById("fullsize").style.zIndex="9999";
              document.getElementById("fullsize").style.width="100px ";
              document.getElementById("fullsize").style.left="90% ";
              document.getElementById("renderCanvas").scrollIntoView({ behavior: 'auto' });

    }else{
            canvasParent.requestFullscreen();
          screen.orientation.lock('landscape');}
          
            enlargeStatus = true;
          
          enlargeButton.innerHTML ='<img src="https://cdn.shopify.com/s/files/1/0529/0655/7613/files/x-symbol.png?v=1712221194" style="width:30px; height:30px;">'
        }
        else {
           if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
            document.getElementById("renderCanvas").style.width="100%";
              document.getElementById("renderCanvas").style.height="100%";
              document.getElementById("renderCanvas").style.right="0%";
              document.getElementById("renderCanvas").style.top="0%";
              document.getElementById("renderCanvas").style.position="relative";
              document.getElementById("renderCanvas").style.background="white";
              document.getElementById("renderCanvas").style.zIndex="10";
             
 document.getElementById("fullsize").style.width="50px ";
              document.getElementById("fullsize").style.position="relative";
               document.getElementById("fullsize").style.bottom="10% ";
             document.getElementById("fullsize").style.left="85% ";
                
              document.getElementById("fullsize").style.zIndex="11";
              
             
             
    }else{
            document.exitFullscreen();
          screen.orientation.lock('portrait');}
            enlargeStatus = false;
          enlargeButton.style.bottom= "10%";
          enlargeButton.innerHTML ='<img src="https://cyclite.cc/cdn/shop/t/13/assets/fullscreen-icon.png?v=73004943282029693841708428540" style="width:30px; height:30px;">'
        }
    }


function onFullscreenChange() {
    if (!document.fullscreenElement && !document.webkitFullscreenElement && 
        !document.mozFullScreenElement && !document.msFullscreenElement) {
        console.log("Fullscreen mode has been exited");
             enlargeStatus = false;
          enlargeButton.style.bottom= "10%";
          enlargeButton.innerHTML ='<img src="https://cyclite.cc/cdn/shop/t/13/assets/fullscreen-icon.png?v=73004943282029693841708428540" style="width:30px; height:30px;">'
    }
}

document.addEventListener("fullscreenchange", onFullscreenChange);
document.addEventListener("webkitfullscreenchange", onFullscreenChange);
document.addEventListener("mozfullscreenchange", onFullscreenChange);
document.addEventListener("MSFullscreenChange", onFullscreenChange);

 startRender();
  KonfigTracking.init();




    document.getElementById("canvas-style").addEventListener("click",startEngine, { once: true });
      document.getElementById("canvas-style").addEventListener("touchstart",startEngine, { once: true });

function startEngine(scene){
  document.getElementById("canvas-style").style.backgroundImage = "none"; 
  document.getElementById("canvas-style").style.background = "white"; 

  
}
    


      
    

      //// SCRIPT 3D 




const modelViewerVariants = document.querySelector("model-viewer#elitescreens-saker");
        const select = document.querySelector('#variant');
        const playButton = document.querySelector('#anim-controls');

        self.ModelViewerElement = self.ModelViewerElement || {};
        self.ModelViewerElement.meshoptDecoderLocation = 'assets/meshopt.js';


const availability = [];

var rBar = document.getElementById("rfill");
  var renderCanvas = document.getElementById("renderCanvas");
renderCanvas.addEventListener("wheel", evt => evt.preventDefault());
var vol = 0;
var price =0;
var weight =0;
var newprice =0;

var col = 1;

//console.log(productAvailability[2].variants[col].available);

function addStats(v,p,w){
  console.log(locale);
  console.log(v,p,w);
  vol =  (parseFloat(vol) + parseFloat(v)).toFixed(1);
  price =  (parseFloat(price) + parseFloat(p)).toFixed(2);
  weight =  (parseFloat(weight) + parseFloat(w)).toFixed(0);

  if(price/480 >1 ){
 rBar.style.width = "100%";
  }else{
      rBar.style.width = ((price / 480)*100 ) + "%";
 }

 if(locale=="de"){
  document.getElementById("itemvolume").innerHTML = "Volumen: " + vol+" l";
  document.getElementById("itemweight").innerHTML = "Gewicht: "+ weight+" g";
  document.getElementById("pricespan").innerHTML = price.replace('.', ',');
       if(price > 650){
    newprice  = (price*0.85).toFixed(2).replace('.', ',');
    document.getElementById("pricespan").innerHTML = newprice;
      document.getElementById("rabatt").innerHTML = "inklusive 15% Set-Rabatt";
  }else if(price> 480){
    newprice= (price*0.88).toFixed(2).replace('.', ',');
    document.getElementById("pricespan").innerHTML =newprice;
    document.getElementById("rabatt").innerHTML = "inklusive 12% Set-Rabatt | noch weitere " + (650-price).toFixed(2).replace('.', ',') +"€ für 15% Set-Rabatt";
  }else if(price<480){
      document.getElementById("rabatt").innerHTML = "Es fehlen "+ (480-price).toFixed(2).replace('.', ',') +" € für 12% Set-Rabatt";
  }
 } if(locale=="en"){
        console.log("addstats EN");
                      document.getElementById("itemvolume").innerHTML = "Volume: " + vol+" l";
  document.getElementById("itemweight").innerHTML = "Weight "+ weight+" g";
  document.getElementById("pricespan").innerHTML = price.replace('.', ',');

     if(price > 650){
    newprice  = (price*0.85).toFixed(2).replace('.', ',');
    document.getElementById("pricespan").innerHTML = newprice;
      document.getElementById("rabatt").innerHTML = "including 15% set discount";
  }else if(price> 480){
    newprice= (price*0.88).toFixed(2).replace('.', ',');
    document.getElementById("pricespan").innerHTML =newprice;
    document.getElementById("rabatt").innerHTML = "including 12% set discount | plus another "  + (650-price).toFixed(2).replace('.', ',')  +"€ for a 15% set discount";
  }else if(price<480){
      document.getElementById("rabatt").innerHTML =(480-price).toFixed(2).replace('.', ',') +" € missing for 12% set discount";
  }
                     
} if(locale=="fr"){
  console.log("addstats FR");
   document.getElementById("itemvolume").innerHTML = "Volume: " + vol+" l";
  document.getElementById("itemweight").innerHTML = "Poids "+ weight+" g";
  document.getElementById("pricespan").innerHTML = price.replace('.', ',');

     if(price > 650){
    newprice  = (price*0.85).toFixed(2).replace('.', ',');
    document.getElementById("pricespan").innerHTML = newprice;
      document.getElementById("rabatt").innerHTML = "incl. 15 % de réduction";
  }else if(price> 480){
    newprice= (price*0.88).toFixed(2).replace('.', ',');
    document.getElementById("pricespan").innerHTML =newprice;
    document.getElementById("rabatt").innerHTML = "incl. 12 % de réduction | encore plus " + (650-price).toFixed(2).replace('.', ',')  +" € pour 15 % de réduction sur le lot";
  }else if(price<480){
      document.getElementById("rabatt").innerHTML ="Il manque " + (480-price).toFixed(2).replace('.', ',')  +" € pour bénéficier de 12 % de réduction sur le Set";
   
}
      


 
     
   




  console.log(price +" "+ newprice);

}
  console.log(price +" "+ newprice);
}
function subStats(v,p,w){
  
  vol =  (parseFloat(vol) - parseFloat(v)).toFixed(1);
  price =  (parseFloat(price) - parseFloat(p)).toFixed(2);
  weight =  (parseFloat(weight) - parseFloat(w)).toFixed(0);

    if(price/480 >1 ){
 rBar.style.width = "100%";
  }else{
      rBar.style.width = ((price / 480)*100) + "%";
 }

  if(locale=="de"){
  document.getElementById("itemvolume").innerHTML = "Volumen: " + vol+" l";
  document.getElementById("itemweight").innerHTML = "Gewicht: "+ weight+" g";
  document.getElementById("pricespan").innerHTML = price.replace('.', ',');

      if(price > 650){
    newprice  = (price*0.85).toFixed(2).replace('.', ',');
    document.getElementById("pricespan").innerHTML = newprice;
      document.getElementById("rabatt").innerHTML = "inklusive 15% Set-Rabatt";
  }else if(price> 480){
    newprice= (price*0.88).toFixed(2).replace('.', ',');
    document.getElementById("pricespan").innerHTML =newprice;
    document.getElementById("rabatt").innerHTML = "inklusive 12% Set-Rabatt | noch weitere "+ (650-price).toFixed(2).replace('.', ',') +"€ für 15% Set-Rabatt";
  }else if(price<480){
      document.getElementById("rabatt").innerHTML = "Es fehlen "+ (480-price).toFixed(2).replace('.', ',') +" € für 12% Set-Rabatt";
  }
    
 }else if(locale=="en"){
      
                      document.getElementById("itemvolume").innerHTML = "Volume: " + vol+" l";
  document.getElementById("itemweight").innerHTML = "Weight: "+ weight+" g";
  document.getElementById("pricespan").innerHTML = price.replace('.', ',');

    
   if(price > 650){
    newprice  = (price*0.85).toFixed(2).replace('.', ',');
    document.getElementById("pricespan").innerHTML = newprice;
      document.getElementById("rabatt").innerHTML = "including 15% set discount";
  }else if(price> 480){
    newprice= (price*0.88).toFixed(2).replace('.', ',');
    document.getElementById("pricespan").innerHTML =newprice;
    document.getElementById("rabatt").innerHTML = "including 12% set discount | plus another "  + (650-price).toFixed(2).replace('.', ',')  +" € for a 15% set discount";
  }else if(price<480){
      document.getElementById("rabatt").innerHTML =(480-price).toFixed(2).replace('.', ',') +" € missing for 12% set discount";
  }
  }  
  else if(locale=="fr"){

   document.getElementById("itemvolume").innerHTML = "Volume: " + vol+" l";
  document.getElementById("itemweight").innerHTML = "Poids: "+ weight+" g";
  document.getElementById("pricespan").innerHTML = price.replace('.', ',');

     if(price > 650){
    newprice  = (price*0.85).toFixed(2).replace('.', ',');
    document.getElementById("pricespan").innerHTML = newprice;
      document.getElementById("rabatt").innerHTML = "incl. 15 % de réduction";
  }else if(price> 480){
    newprice= (price*0.88).toFixed(2).replace('.', ',');
    document.getElementById("pricespan").innerHTML =newprice;
    document.getElementById("rabatt").innerHTML = "incl. 12 % de réduction | encore plus " + (650-price).toFixed(2).replace('.', ',')  +" € pour 15 % de réduction sur le lot";
  }else if(price<480){
      document.getElementById("rabatt").innerHTML ="Il manque " + (480-price).toFixed(2).replace('.', ',') +" € pour bénéficier de 12 % de réduction sur le Set";
   
}
  }
  

 

    
 


  console.log(price +" "+ newprice);

}

// GUI 


// Saddle
var showSaddlebag = document.getElementById("saddlebagbut");
showSaddlebag.addEventListener("click", () => toggleSaddleMain(false));

// Framebag
var showFramebag = document.getElementById("framebagbut");
showFramebag.addEventListener("click", () => toggleframebagMain(false));

// TopTube
var showTopTube = document.getElementById("toptubebut");
showTopTube.addEventListener("click", () => toggleToptubeMain(false));

// Foodpouch (mit e)
var showFoodpouch = document.getElementById("foodpouchbut");
showFoodpouch.addEventListener("click", (e) => toggleFoodpouch(e, false));

// FoodpouchL
var showFoodpouchL = document.getElementById("FPL");
showFoodpouchL.addEventListener("click", (e) => toggleFoodpouchL(e,false));

// FoodpouchR (mit e)
document.getElementById("FPR").addEventListener("click", (e) => toggleFoodpouch(e, false));

// SaddleSmall
var showSaddleS = document.getElementById("saddlebagsbut");
showSaddleS.addEventListener("click", () => toggleSaddleSmallMain(false));

// SaddleNano
var showSaddleN = document.getElementById("saddlebagnbut");
showSaddleN.addEventListener("click", () => toggleSaddleNano(false));

// TopTubeL
var showTopTubel = document.getElementById("toptubelbut");
showTopTubel.addEventListener("click", () => toggleToptubel(false));

// TopTubeN
var showTopTubeN = document.getElementById("toptubenbut");
showTopTubeN.addEventListener("click", () => toggleToptubeN(false));

// FramebagL
var showFramebagl = document.getElementById("framebaglbut");
showFramebagl.addEventListener("click", () => toggleframebaglMain(false));

// Roll
var showRoll = document.getElementById("rollbut");
showRoll.addEventListener("click", () => toggleRoll(false));

// Aero
var showAero = document.getElementById("aerobut");
showAero.addEventListener("click", () => toggleAero(false));

// FramebagXT
var showFramebagXT = document.getElementById("framebagxtbut");
showFramebagXT.addEventListener("click", () => toggleFramebagXT(false));

// FramebagSmall
var showFramebagSmall = document.getElementById("framebagsmallbut");
showFramebagSmall.addEventListener("click", () => toggleFramebagSmall(false));

// Forkbag (mit e)
var showForkbag = document.getElementById("forkbagbut");
showForkbag.addEventListener("click", (e) => toggleForkbagR(e, false));

// ForkbagR (mit e)
document.getElementById("FoBR").addEventListener("click", (e) => toggleForkbagR(e, false));

// ForkbagL
var showForkbagL = document.getElementById("FoBL");
showForkbagL.addEventListener("click", (e) => toggleForkbagL(e, false));

// Handlebar
var showHBBN = document.getElementById("handlebarnbut");
showHBBN.addEventListener("click", () => toggleHBBN(false));

var visHBBN = true; 

function toggleHBBN(fromSet=false){  
 
  if(!visAero && !visRoll){
                   aerorollMesh.dispose();
                     removeItem(5);
                     document.querySelector("#cardRB").remove();
                     document.querySelector("#cardAB").remove();
                     visRoll=!visRoll;
                     visAero=!visAero;
                         showRoll.style.border="3px solid #e3e3e3";
                         showAero.style.border="3px solid #e3e3e3";
   
        subStats(showRoll.getAttribute("data-vol"),showRoll.getAttribute("data-price"),showRoll.getAttribute("data-weight"));
        subStats(showAero.getAttribute("data-vol"),showAero.getAttribute("data-price"),showAero.getAttribute("data-weight"));


            }

             if(!visAero){
                   aeroMesh.dispose();
                     removeItem(4);
                     document.querySelector("#cardAB").remove();
                     visAero=!visAero;    
                    showAero.style.border="3px solid #e3e3e3";
   
        subStats(showAero.getAttribute("data-vol"),showAero.getAttribute("data-price"),showAero.getAttribute("data-weight"));


            }

             if(!visRoll){
                   rollMesh.dispose();
                     removeItem(5);
                     document.querySelector("#cardRB").remove();
                     visRoll=!visRoll;
                    showRoll.style.border="3px solid #e3e3e3";
        subStats(showRoll.getAttribute("data-vol"),showRoll.getAttribute("data-price"),showRoll.getAttribute("data-weight"));


            }
  
  if (visHBBN){
     if (!fromSet) KonfigTracking.track('Produkt', 'HANDLE BAR BAG NANO');
    renderHBBN();
    showHBBN.style.border="3px solid black";
    addStats(showHBBN.getAttribute("data-vol"),showHBBN.getAttribute("data-price"),showHBBN.getAttribute("data-weight"));   
    visHBBN=!visHBBN;
     appendItem(showHBBN.getAttribute("data-"+color),4,13,color);

     if(color=="weiß"){
    document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardHBBN">
      <button id="closeHBBN" class="closecard">-</button>
      <img class="imgCard" src="https://9k186x5y31hjh0cf-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-BAG-NANO-01_Light-Grey_Studio_01_720x.jpg?v=1761825334">
      <p style="text-align:center;font-weight:bold;font-size: 12px;">HANDLE BAR BAG NANO</p>
    </div>
  `);

                 document.querySelector('#handlebarnbut .prod-pics').src = 'https://9k186x5y31hjh0cf-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-BAG-NANO-01_Light-Grey_Studio_01_1800x1800.jpg?v=1761825334';


}else{
 document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardHBBN">
      <button id="closeHBBN" class="closecard">-</button>
      <img class="imgCard" src="https://9k186x5y31hjh0cf-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-BAG-NANO-01_Black_Studio_01_1800x1800.jpg?v=1761825334">
      <p style="text-align:center;font-weight:bold;font-size: 12px;">HANDLE BAR BAG NANO</p>
    </div>
  `);
            document.querySelector('#handlebarnbut .prod-pics').src = 'https://9k186x5y31hjh0cf-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-BAG-NANO-01_Black_Studio_01_1800x1800.jpg?v=1761825334';

}
document.getElementById("closeHBBN")
document.getElementById("closeHBBN").addEventListener("click", toggleHBBN);


  }else{
    disposeHBBN();
    visHBBN=!visHBBN;
    showHBBN.style.border="3px solid #e3e3e3";
    removeItem(4);
    subStats(showHBBN.getAttribute("data-vol"),showHBBN.getAttribute("data-price"),showHBBN.getAttribute("data-weight"));
    document.querySelector("#cardHBBN").remove();
  }

  
    
}


var visForkbagR = true; 

function toggleForkbagR(e, fromSet=false){  
 
  e.stopPropagation(); 

  if (visForkbagR){
     if (!fromSet) KonfigTracking.track('Produkt', 'FORK BAG RIGHT');
    renderForkbagR();
    showForkbag.style.border="3px solid black";
    document.getElementById("FoBR").style.border="1px solid black";
    addStats(showForkbag.getAttribute("data-vol"),showForkbag.getAttribute("data-price"),showForkbag.getAttribute("data-weight"));   
    visForkbagR=!visForkbagR;
     appendItem(showForkbag.getAttribute("data-"+color+"R"),6,14,color);

     
     if(color=="weiß"){
    document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardFoB">
      <button id="closeFoB" class="closecard">-</button>
      <img class="imgCard" src="https://kouv8jiwdeqin0c7-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FORK-BAG-01_Light-Grey_Studio_04.jpg?v=1761737650&width=1400">
      <p style="text-align:center;font-weight:bold;font-size: 12px;">FORK BAG R</p>
    </div>
  `);

              document.querySelector('#forkbagbut .prod-pics').src = 'https://kouv8jiwdeqin0c7-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FORK-BAG-01_Light-Grey_Studio_04.jpg?v=1761737650&width=1400';

  }else{
 document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardFoB">
      <button id="closeFoB" class="closecard">-</button>
      <img class="imgCard" src="https://kouv8jiwdeqin0c7-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FORK-BAG-01_Black_Studio_03.jpg?v=1761737650&width=1400">
      <p style="text-align:center;font-weight:bold;font-size: 12px;">FORK BAG R</p>
    </div>
  `);
         document.querySelector('#forkbagbut .prod-pics').src = 'https://kouv8jiwdeqin0c7-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FORK-BAG-01_Black_Studio_03.jpg?v=1761737650&width=1400';

  }
document.getElementById("closeFoB")
document.getElementById("closeFoB").addEventListener("click", toggleForkbagR);


  }else{
    disposeForkbagR();
    visForkbagR=!visForkbagR;

     if(visForkbagL){
    showForkbag.style.border="3px solid #e3e3e3";
  }
   
        document.getElementById("FoBR").style.border="1px solid lightgrey";

    removeItem(6);
    subStats(showForkbag.getAttribute("data-vol"),showForkbag.getAttribute("data-price"),showForkbag.getAttribute("data-weight"));
    document.querySelector("#cardFoB").remove();
  }

  
    
}


var visForkbagL = true; 

function toggleForkbagL(e,fromSet=false){  
 
  e.stopPropagation(); 

  if (visForkbagL){
     if (!fromSet) KonfigTracking.track('Produkt', 'FORK BAG LEFT');
    renderForkbagL();
    
    document.getElementById("FoBL").style.border="1px solid black";
       
         showForkbag.style.border="3px solid black";

    addStats(showForkbag.getAttribute("data-vol"),showForkbag.getAttribute("data-price"),showForkbag.getAttribute("data-weight"));   
    visForkbagL=!visForkbagL;
     appendItem(showForkbag.getAttribute("data-"+color+"L"),7,14,color);

     
     if(color=="weiß"){
    document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardFoBL">
      <button id="closeFoBL" class="closecard">-</button>
      <img class="imgCard" src="https://kouv8jiwdeqin0c7-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FORK-BAG-01_Light-Grey_Studio_04.jpg?v=1761737650&width=1400">
      <p style="text-align:center;font-weight:bold;font-size: 12px;">FORK BAG L</p>
    </div>
  `);

              document.querySelector('#forkbagbut .prod-pics').src = 'https://kouv8jiwdeqin0c7-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FORK-BAG-01_Light-Grey_Studio_04.jpg?v=1761737650&width=1400';

  }else{
 document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardFoBL">
      <button id="closeFoBL" class="closecard">-</button>
      <img class="imgCard" src="https://kouv8jiwdeqin0c7-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FORK-BAG-01_Black_Studio_03.jpg?v=1761737650&width=1400">
      <p style="text-align:center;font-weight:bold;font-size: 12px;">FORK BAG L</p>
    </div>
  `);
         document.querySelector('#forkbagbut .prod-pics').src = 'https://kouv8jiwdeqin0c7-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FORK-BAG-01_Black_Studio_03.jpg?v=1761737650&width=1400';

  }
document.getElementById("closeFoBL")
document.getElementById("closeFoBL").addEventListener("click", toggleForkbagL);


  }else{
    disposeForkbagL();
    visForkbagL=!visForkbagL;

    if(visForkbagR){
    showForkbag.style.border="3px solid #e3e3e3";
  }
    document.getElementById("FoBL").style.border="1px solid lightgrey";
    removeItem(7);
    subStats(showForkbag.getAttribute("data-vol"),showForkbag.getAttribute("data-price"),showForkbag.getAttribute("data-weight"));
    document.querySelector("#cardFoBL").remove();
  }

  
    
}

var visFoodpouchL = true

function toggleFoodpouchL(e, fromSet=false){
  if (e && typeof e.stopPropagation === "function") {
    e.stopPropagation();
  } 
  if(visFoodpouchL){
     if (!fromSet) KonfigTracking.track('Produkt', 'FOOD POUCH LEFT');
    renderFoodpouchL();
    visFoodpouchL=!visFoodpouchL;
    showFoodpouch.style.border="3px solid black";
    showFoodpouchL.style.border="1px solid black";
   appendItem(showFoodpouch.getAttribute("data-"+color),7,8,color);
    addStats(showFoodpouch.getAttribute("data-vol"),showFoodpouch.getAttribute("data-price"),showFoodpouch.getAttribute("data-weight"));

       

  if(color=="weiß"){
    document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardFPL">
      <button id="closeFPL" class="closecard">-</button>
      <img class="imgCard" src="https://cyclite.cc/cdn/shop/files/CYCLITE_FOOD-POUCH-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761825503">
      <p style="text-align:center;font-weight:bold;font-size: 12px;" id="FPtxt">FOOD POUCH L</p>
    </div>
  `);

                         document.querySelector('#foodpouchbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FOOD-POUCH-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761825503';

  }else{
   document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardFPL">
      <button id="closeFPL" class="closecard">-</button>
      <img class="imgCard" src="https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FOOD-POUCH-02_Black_Studio_01_1800x1800.jpg?v=1761825503">
      <p style="text-align:center;font-weight:bold;font-size: 12px;" id="FPtxt">FOOD POUCH L</p>
    </div>
  `);
                   document.querySelector('#foodpouchbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FOOD-POUCH-02_Black_Studio_01_1800x1800.jpg?v=1761825503';


  }
 
document.getElementById("closeFPL")
document.getElementById("closeFPL").addEventListener("click", toggleFoodpouchL);


  


  }
  else{
    disposeFoodpouchL();
    visFoodpouchL=!visFoodpouchL;

       showFoodpouchL.style.border="1px solid #e3e3e3";

    if(visFoodpouch){
    showFoodpouch.style.border="3px solid #e3e3e3";
  }
       // showFoodpouch.style.border="3px solid #e3e3e3";
    removeItem(8);
    subStats(showFoodpouch.getAttribute("data-vol"),showFoodpouch.getAttribute("data-price"),showFoodpouch.getAttribute("data-weight"));



  document.querySelector("#cardFPL").remove();


  

  }

}


var visFramebagSmall = true; 

function toggleFramebagSmall(fromSet=false){  
    if(!visFramebagl){
    disposeFramebagl();
    visFramebagl=!visFramebagl;
    showFramebagl.style.border="3px solid #e3e3e3";
    subStats(showFramebagl.getAttribute("data-vol"),showFramebagl.getAttribute("data-price"),showFramebagl.getAttribute("data-weight"));
 document.querySelector("#cardFBL").remove();
  }
    if(!visFramebag){
    disposeFramebag();
    visFramebag=!visFramebag;
    showFramebag.style.border="3px solid #e3e3e3";
    subStats(showFramebagSmall.getAttribute("data-vol"),showFramebagSmall.getAttribute("data-price"),showFramebagSmall.getAttribute("data-weight"));
 document.querySelector("#cardFB").remove();
  }

  if(!visFramebagXT){
    disposeFramebagXT();
    visFramebagXT=!visFramebagXT;
    showFramebagXT.style.border="3px solid #e3e3e3";
    subStats(showFramebagSmall.getAttribute("data-vol"),showFramebagSmall.getAttribute("data-price"),showFramebagSmall.getAttribute("data-weight"));
 document.querySelector("#cardFBXT").remove();
  }
  
  if (visFramebagSmall){
     if (!fromSet) KonfigTracking.track('Produkt', 'FRAME BAG SMALL');
    renderFramebagSmall();
    showFramebagSmall.style.border="3px solid black";
    addStats(showFramebagSmall.getAttribute("data-vol"),showFramebagSmall.getAttribute("data-price"),showFramebagSmall.getAttribute("data-weight"));   
    visFramebagSmall=!visFramebagSmall;
     appendItem(showFramebagSmall.getAttribute("data-"+color),2,10);

     if(color=="weiß"){
    document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardFBS">
      <button id="closeFBS" class="closecard">-</button>
      <img class="imgCard" src="https://cyclite.cc/cdn/shop/files/CYCLITE_FRAME-BAG-SMALL-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761837246">
      <p style="text-align:center;font-weight:bold;font-size: 12px;">FRAME BAG SMALL</p>
    </div>
  `);

  document.querySelector('#framebagsmallbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FRAME-BAG-SMALL-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761837246';


  }else{

      document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardFBS">
      <button id="closeFBS" class="closecard">-</button>
      <img class="imgCard" src="https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FRAME-BAG-SMALL-02_Black_Studio_01_1800x1800.jpg?v=1761837246">
      <p style="text-align:center;font-weight:bold;font-size: 12px;">FRAME BAG SMALL</p>
    </div>
  `);

    document.querySelector('#framebagsmallbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FRAME-BAG-SMALL-02_Black_Studio_01_1800x1800.jpg?v=1761837246';

  }
document.getElementById("closeFBS")
document.getElementById("closeFBS").addEventListener("click", toggleFramebagSmall);


  }else{
    disposeFramebagSmall();
    visFramebagSmall=!visFramebagSmall;
    showFramebagSmall.style.border="3px solid #e3e3e3";
    removeItem(2);
    subStats(showFramebagSmall.getAttribute("data-vol"),showFramebagSmall.getAttribute("data-price"),showFramebagSmall.getAttribute("data-weight"));
    document.querySelector("#cardFBS").remove();
  }

  
    
}



var visFramebagXT = true; 

function toggleFramebagXT(fromSet=false){  
    if(!visFramebagl){
    disposeFramebagl();
    visFramebagl=!visFramebagl;
    showFramebagl.style.border="3px solid #e3e3e3";
    subStats(showFramebagl.getAttribute("data-vol"),showFramebagl.getAttribute("data-price"),showFramebagl.getAttribute("data-weight"));
document.querySelector("#cardFBL").remove();
  }
    if(!visFramebag){
    disposeFramebag();
    visFramebag=!visFramebag;
    showFramebag.style.border="3px solid #e3e3e3";
    subStats(showFramebag.getAttribute("data-vol"),showFramebag.getAttribute("data-price"),showFramebag.getAttribute("data-weight"));
document.querySelector("#cardFB").remove();
  }

  if(!visFramebagSmall){
    disposeFramebagSmall();
    visFramebagSmall=!visFramebagSmall;
    showFramebagSmall.style.border="3px solid #e3e3e3";
    subStats(showFramebagSmall.getAttribute("data-vol"),showFramebagSmall.getAttribute("data-price"),showFramebagSmall.getAttribute("data-weight"));
  document.querySelector("#cardFBS").remove();
  }
  
  if (visFramebagXT){
     if (!fromSet) KonfigTracking.track('Produkt', 'FRAME BAG XT');
    renderFramebagXT();
    showFramebagXT.style.border="3px solid black";
    addStats(showFramebagXT.getAttribute("data-vol"),showFramebagXT.getAttribute("data-price"),showFramebagXT.getAttribute("data-weight"));   
    visFramebagXT=!visFramebagXT;
     appendItem(showFramebagXT.getAttribute("data-"+color),2,9);

       if(color=="weiß"){
    document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardFBXT">
      <button id="closeFBXT" class="closecard">-</button>
      <img class="imgCard" src="https://cyclite.cc/cdn/shop/files/CYCLITE_FRAME-BAG-XT-02_Light-Grey_01_15302eb5-672d-4a84-8e9a-71372852a12b_1800x1800.jpg?v=1761739026">
      <p style="text-align:center;font-weight:bold;font-size: 12px;">FRAME BAG XT</p>
    </div>
  `);

                    document.querySelector('#framebagxtbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FRAME-BAG-XT-02_Light-Grey_01_15302eb5-672d-4a84-8e9a-71372852a12b_1800x1800.jpg?v=1761739026';


  }else{

   document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardFBXT">
      <button id="closeFBXT" class="closecard">-</button>
      <img class="imgCard" src="https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FRAME-BAG-XT-02_Black_Studio_01_82165cac-6a56-4d9d-8807-8e1ef6a9ffd0_1800x1800.jpg?v=1761739026">
      <p style="text-align:center;font-weight:bold;font-size: 12px;">FRAME BAG XT</p>
    </div>
  `);
                  document.querySelector('#framebagxtbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FRAME-BAG-XT-02_Black_Studio_01_82165cac-6a56-4d9d-8807-8e1ef6a9ffd0_1800x1800.jpg?v=1761739026';


  }
document.getElementById("closeFBXT")
document.getElementById("closeFBXT").addEventListener("click", toggleFramebagXT);


  }else{
    disposeFramebagXT();
    visFramebagXT=!visFramebagXT;
    showFramebagXT.style.border="3px solid #e3e3e3";
     removeItem(2);
    subStats(showFramebagXT.getAttribute("data-vol"),showFramebagXT.getAttribute("data-price"),showFramebagXT.getAttribute("data-weight"));
    document.querySelector("#cardFBXT").remove();
  }

  
    
}


// funktion um Modell zu rendern
var visSaddlebag = true;



function toggleSaddleMain(fromSet=false){
  
  if(visSaddlebag){
    if(!visSaddleSmall){
    disposeSaddlebagSmall();
    visSaddleSmall=!visSaddleSmall;
    showSaddleS.style.border="3px solid #e3e3e3";
    subStats(showSaddleS.getAttribute("data-vol"),showSaddleS.getAttribute("data-price"),showSaddleS.getAttribute("data-weight"));
 document.querySelector("#cardSBS").remove();
  }

   if(!visSaddlebagN){
    disposeSaddlebagNano();
    visSaddlebagN=!visSaddlebagN;
    showSaddleN.style.border="3px solid #e3e3e3";
    subStats(showSaddleN.getAttribute("data-vol"),showSaddleN.getAttribute("data-price"),showSaddleN.getAttribute("data-weight"));
 document.querySelector("#cardSBN").remove();
  }
  if (!fromSet) KonfigTracking.track('Produkt', 'SADDLE BAG');
    renderSaddlebag();
    visSaddlebag=!visSaddlebag;
    showSaddlebag.style.border="3px solid black";
    appendItem(showSaddlebag.getAttribute("data-"+color),1,6,color);
    addStats(showSaddlebag.getAttribute("data-vol"),showSaddlebag.getAttribute("data-price"),showSaddlebag.getAttribute("data-weight"));

    if(color=="weiß"){
    document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardSB">
      <button id="closeSB" class="closecard">-</button>
      <img class="imgCard" src="https://cyclite.cc/cdn/shop/files/CYCLITE_SADDLE-BAG-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761739753">
      <p style="text-align:center;font-weight:bold;font-size: 12px;" >SADDLE BAG</p>
    </div>
  `);
   document.querySelector('#saddlebagbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_SADDLE-BAG-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761739753';

    }else{
 document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardSB">
      <button id="closeSB" class="closecard">-</button>
      <img class="imgCard" src="https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_SADDLE-BAG-02_Black_Studio_01_1800x1800.jpg?v=1761739753">
      <p style="text-align:center;font-weight:bold;font-size: 12px;" >SADDLE BAG</p>
    </div>
  `);

                        document.querySelector('#saddlebagbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_SADDLE-BAG-02_Black_Studio_01_1800x1800.jpg?v=1761739753';


    }
document.getElementById("closeSB")
document.getElementById("closeSB").addEventListener("click", toggleSaddleMain);
//remove();
  
}
  else{
    disposeSaddlebago();
    visSaddlebag=!visSaddlebag;
    showSaddlebag.style.border="3px solid #e3e3e3";
    removeItem(1);
    subStats(showSaddlebag.getAttribute("data-vol"),showSaddlebag.getAttribute("data-price"),showSaddlebag.getAttribute("data-weight"));
    document.querySelector("#cardSB").remove();

  }

}

var visSaddleSmall = true;
function toggleSaddleSmallMain(fromSet=false){

  if(visSaddleSmall){
   if(!visSaddlebag){
    disposeSaddlebago();
    visSaddlebag=!visSaddlebag;
    showSaddlebag.style.border="3px solid #e3e3e3";
    subStats(showSaddlebag.getAttribute("data-vol"),showSaddlebag.getAttribute("data-price"),showSaddlebag.getAttribute("data-weight"));
 document.querySelector("#cardSB").remove();
   }

    if(!visSaddlebagN){
    disposeSaddlebagNano();
    visSaddlebagN=!visSaddlebagN;
    showSaddleN.style.border="3px solid #e3e3e3";
    subStats(showSaddleN.getAttribute("data-vol"),showSaddleN.getAttribute("data-price"),showSaddleN.getAttribute("data-weight"));
 document.querySelector("#cardSBN").remove();
  }
  if (!fromSet) KonfigTracking.track('Produkt', 'SADDLE BAG SMALL');
    renderSaddlebagS();
    visSaddleSmall=!visSaddleSmall;
    showSaddleS.style.border="3px solid black";
    appendItem(showSaddleS.getAttribute("data-"+color),1,7,color);
    addStats(showSaddleS.getAttribute("data-vol"),showSaddleS.getAttribute("data-price"),showSaddleS.getAttribute("data-weight"));

    if(color=="weiß"){
    document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardSBS">
      <button id="closeSBS" class="closecard">-</button>
      <img class="imgCard" src="https://nj1e39qec99fwgt0-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_SADDLE-BAG-SMALL-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761827654">
      <p style="text-align:center;font-weight:bold;font-size: 12px;">SADDLE BAG SMALL</p>
    </div>
  `);

        document.querySelector('#saddlebagsbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_SADDLE-BAG-SMALL-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761827654';


  }else{
   document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardSBS">
      <button id="closeSBS" class="closecard">-</button>
      <img class="imgCard" src="https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_SADDLE-BAG-SMALL-02_Black_Studio_01_1800x1800.jpg?v=1761827654">
      <p style="text-align:center;font-weight:bold;font-size: 12px;">SADDLE BAG SMALL</p>
    </div>
  `);
document.querySelector('#saddlebagsbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_SADDLE-BAG-SMALL-02_Black_Studio_01_1800x1800.jpg?v=1761827654';
  }
document.getElementById("closeSBS")
document.getElementById("closeSBS").addEventListener("click", toggleSaddleSmallMain);

  }
  else{
    disposeSaddlebagSmall();
    visSaddleSmall=!visSaddleSmall;
    showSaddleS.style.border="3px solid #e3e3e3";
    removeItem(1);
    subStats(showSaddleS.getAttribute("data-vol"),showSaddleS.getAttribute("data-price"),showSaddleS.getAttribute("data-weight"));
    document.querySelector("#cardSBS").remove();
  }

}


var visSaddlebagN = true;

function toggleSaddleNano(fromSet=false){

     

  if(visSaddlebagN){

   if(!visSaddleSmall){
    disposeSaddlebagSmall();
    visSaddleSmall=!visSaddleSmall;
    showSaddleS.style.border="3px solid #e3e3e3";
    subStats(showSaddleS.getAttribute("data-vol"),showSaddleS.getAttribute("data-price"),showSaddleS.getAttribute("data-weight"));
 document.querySelector("#cardSBS").remove();
   }
    if(!visSaddlebag){
    disposeSaddlebago();
    visSaddlebag=!visSaddlebag;
    showSaddlebag.style.border="3px solid #e3e3e3";
    subStats(showSaddlebag.getAttribute("data-vol"),showSaddlebag.getAttribute("data-price"),showSaddlebag.getAttribute("data-weight"));
 document.querySelector("#cardSB").remove();
   }
  if (!fromSet) KonfigTracking.track('Produkt', 'SADDLE BAG NANO');
    renderSaddlebagNano();
    visSaddlebagN=!visSaddlebagN;
    showSaddleN.style.border="3px solid black";
    appendItem(showSaddleN.getAttribute("data-"+color),1,12,color);
    addStats(showSaddleN.getAttribute("data-vol"),showSaddleN.getAttribute("data-price"),showSaddleN.getAttribute("data-weight"));

    if(color=="weiß"){
    document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardSBN">
      <button id="closeSBN" class="closecard">-</button>
      <img class="imgCard" src="https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_SADDLE-BAG-NANO-01_Light-Grey_Studio_01_1800x1800.jpg?v=1761827081">
      <p style="text-align:center;font-weight:bold;font-size: 12px;">SADDLE BAG NANO</p>
    </div>
  `);

        document.querySelector('#saddlebagnbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_SADDLE-BAG-NANO-01_Light-Grey_Studio_01_1800x1800.jpg?v=1761827081';


  }else{
document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardSBN">
      <button id="closeSBN" class="closecard">-</button>
      <img class="imgCard" src="https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_SADDLE-BAG-NANO-01_Black_Studio_02_1800x1800.jpg?v=1761827081">
      <p style="text-align:center;font-weight:bold;font-size: 12px;">SADDLE BAG NANO</p>
    </div>
  `);
   document.querySelector('#saddlebagnbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_SADDLE-BAG-NANO-01_Black_Studio_02_1800x1800.jpg?v=1761827081';

  }
document.getElementById("closeSBN")
document.getElementById("closeSBN").addEventListener("click", toggleSaddleNano);

  }
  else{
    disposeSaddlebagNano();
    visSaddlebagN=!visSaddlebagN;
    showSaddleN.style.border="3px solid #e3e3e3";
    removeItem(1);
    subStats(showSaddleN.getAttribute("data-vol"),showSaddleN.getAttribute("data-price"),showSaddleN.getAttribute("data-weight"));
    document.querySelector("#cardSBN").remove();
  }

}

var visFramebag = true;
function toggleframebagMain(fromSet=false){

  if(!visFramebagl){
    disposeFramebagl();
    visFramebagl=!visFramebagl;
    showFramebagl.style.border="3px solid #e3e3e3";
    subStats(showFramebagl.getAttribute("data-vol"),showFramebagl.getAttribute("data-price"),showFramebagl.getAttribute("data-weight"));
    document.querySelector("#cardFBL").remove();
  }

  if(!visFramebagXT){
    disposeFramebagXT();
    visFramebagXT=!visFramebagXT;
    showFramebagXT.style.border="3px solid #e3e3e3";
    subStats(showFramebagXT.getAttribute("data-vol"),showFramebagXT.getAttribute("data-price"),showFramebagXT.getAttribute("data-weight"));
    document.querySelector("#cardFBXT").remove();
  }

  if(!visFramebagSmall){
    disposeFramebagSmall();
    visFramebagSmall=!visFramebagSmall;
    showFramebagSmall.style.border="3px solid #e3e3e3";
    subStats(showFramebagSmall.getAttribute("data-vol"),showFramebagSmall.getAttribute("data-price"),showFramebagSmall.getAttribute("data-weight"));
    document.querySelector("#cardFBS").remove();
  }

  if(visFramebag){
    if (!fromSet) KonfigTracking.track('Produkt', 'FRAME BAG');
    renderFramebag();
    visFramebag=!visFramebag;
    showFramebag.style.border="3px solid black";
    appendItem(showFramebag.getAttribute("data-"+color),2,4,color);
    addStats(showFramebag.getAttribute("data-vol"),showFramebag.getAttribute("data-price"),showFramebag.getAttribute("data-weight"));
    console.log(color);

     if(color=="weiß"){
    document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardFB">
      <button id="closeFB" class="closecard">-</button>
      <img class="imgCard" src="https://cyclite.cc/cdn/shop/files/CYCLITE_FRAME-BAG-03_Light_grey_Studio_01_1800x1800.jpg?v=1765864945">
      <p style="text-align:center;font-weight:bold;font-size: 12px;">FRAME BAG </p>
    </div>
  `);
                document.querySelector('#framebagbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FRAME-BAG-03_Light_grey_Studio_01_1800x1800.jpg?v=1765864945';

  }else{

  document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardFB">
      <button id="closeFB" class="closecard">-</button>
      <img class="imgCard" src="https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FRAME-BAG-03_Black_Studio_01_720x.jpg?v=1765864945">
      <p style="text-align:center;font-weight:bold;font-size: 12px;">FRAME BAG </p>
    </div>
  `);
                document.querySelector('#framebagbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FRAME-BAG-03_Black_Studio_01_720x.jpg?v=1765864945';



  }
document.getElementById("closeFB")
document.getElementById("closeFB").addEventListener("click", toggleframebagMain);

  }
  else{
    
    disposeFramebag();
    visFramebag=!visFramebag;
    showFramebag.style.border="3px solid #e3e3e3";
    removeItem(2);
    subStats(showFramebag.getAttribute("data-vol"),showFramebag.getAttribute("data-price"),showFramebag.getAttribute("data-weight"));

    document.querySelector("#cardFB").remove();
  }

}

///


function appendItem(value, ind,v,col){
  formData.items[ind]=
  {
    'id': value,
    'quantity': 1,
     'col':col
    }
  availability[ind]=v;

  console.log(formData);
}

//
function removeItem(ind){
formData.items[ind]= undefined;
  availability[ind]=undefined;
}

var visFramebagl = true;
function toggleframebaglMain(fromSet=false){
  if(!visFramebag){
    disposeFramebag();
    visFramebag=!visFramebag;
    showFramebag.style.border="3px solid #e3e3e3";
    subStats(showFramebag.getAttribute("data-vol"),showFramebag.getAttribute("data-price"),showFramebag.getAttribute("data-weight"));
document.querySelector("#cardFB").remove();
  }
    if(!visFramebagXT){
    disposeFramebagXT();
    visFramebagXT=!visFramebagXT;
    showFramebagXT.style.border="3px solid #e3e3e3";
    subStats(showFramebagXT.getAttribute("data-vol"),showFramebagXT.getAttribute("data-price"),showFramebagXT.getAttribute("data-weight"));
  document.querySelector("#cardFBXT").remove();
  }

  if(!visFramebagSmall){
    disposeFramebagSmall();
    visFramebagSmall=!visFramebagSmall;
    showFramebagSmall.style.border="3px solid #e3e3e3";
    subStats(showFramebagSmall.getAttribute("data-vol"),showFramebagSmall.getAttribute("data-price"),showFramebagSmall.getAttribute("data-weight"));
document.querySelector("#cardFBS").remove();
  }


  if(visFramebagl){
     if (!fromSet) KonfigTracking.track('Produkt', 'FRAME BAG LARGE');
    renderFramebagl();
    visFramebagl=!visFramebagl;
    showFramebagl.style.border="3px solid black";
    appendItem(showFramebagl.getAttribute("data-"+color),2,5,color);
    addStats(showFramebagl.getAttribute("data-vol"),showFramebagl.getAttribute("data-price"),showFramebagl.getAttribute("data-weight"));
 
    if(color=="weiß"){
    document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardFBL">
      <button id="closeFBL" class="closecard">-</button>
      <img class="imgCard" src="https://cyclite.cc/cdn/shop/files/CYCLITE_FRAME-BAG-LARGE-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761737018">
      <p style="text-align:center;font-weight:bold;font-size: 12px;font-size: 12px;">FRAME BAG LARGE</p>
    </div>
  `);
               document.querySelector('#framebaglbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FRAME-BAG-LARGE-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761737018';


  }else{

  document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardFBL">
      <button id="closeFBL" class="closecard">-</button>
      <img class="imgCard" src="https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FRAME-BAG-LARGE-02_Black_Studo_01_1800x1800.jpg?v=1761737018">
      <p style="text-align:center;font-weight:bold;font-size: 12px;font-size: 12px;">FRAME BAG LARGE</p>
    </div>
  `);
               document.querySelector('#framebaglbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FRAME-BAG-LARGE-02_Black_Studo_01_1800x1800.jpg?v=1761737018';

  }
document.getElementById("closeFBL")
document.getElementById("closeFBL").addEventListener("click", toggleframebaglMain);

  }
  else{
    disposeFramebagl();
    visFramebagl=!visFramebagl;
    showFramebagl.style.border="3px solid #e3e3e3";
    removeItem(2);
    subStats(showFramebagl.getAttribute("data-vol"),showFramebagl.getAttribute("data-price"),showFramebagl.getAttribute("data-weight"));

 document.querySelector("#cardFBL").remove();
  }
}

///

var visTopTube = true;

function toggleToptubeMain(fromSet=false){
  console.log(color);

  if(!visTopTubel){
    disposeToptubel();
    visTopTubel=!visTopTubel;
    showTopTubel.style.border="3px solid #e3e3e3";
    subStats(showTopTubel.getAttribute("data-vol"),showTopTubel.getAttribute("data-price"),showTopTubel.getAttribute("data-weight"));
    document.querySelector("#cardTTL").remove();
  }

  if(!visTopTubeN){
    disposeTopTubeN();
    visTopTubeN=!visTopTubeN;
    showTopTubeN.style.border="3px solid #e3e3e3";
    subStats(showTopTubeN.getAttribute("data-vol"),showTopTubeN.getAttribute("data-price"),showTopTubeN.getAttribute("data-weight"));
    document.querySelector("#cardTTN").remove();
  }

  if(visTopTube){
     if (!fromSet) KonfigTracking.track('Produkt', 'TOP TUBE');
    renderToptube();
    visTopTube=!visTopTube;
    showTopTube.style.border="3px solid black";
  
      appendItem(showTopTube.getAttribute("data-"+color),3,2,color,color);

    addStats(showTopTube.getAttribute("data-vol"),showTopTube.getAttribute("data-price"),showTopTube.getAttribute("data-weight"));

    if(color=="weiß"){
        document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardTT">
      <button id="closeTT" class="closecard">-</button>
      <img class="imgCard" src="https://cyclite.cc/cdn/shop/files/CYCLITE_TOP-TUBE-BAG-03_Light-Grey_Studio_01_88bcc662-44c0-4558-9363-beed1327eb9c_1800x1800.jpg?v=1761738584">
      <p style="text-align:center;font-weight:bold;font-size: 12px;">TOP TUBE BAG</p>
    </div>
  `);
         document.querySelector('#toptubebut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_TOP-TUBE-BAG-03_Light-Grey_Studio_01_88bcc662-44c0-4558-9363-beed1327eb9c_1800x1800.jpg?v=1761738584';

  }else{
          document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardTT">
      <button id="closeTT" class="closecard">-</button>
      <img class="imgCard" src="https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_TOP-TUBE-BAG-03_Black_Studio_01_4fdc2dc2-fa6a-4d3d-9478-2fadf600d134_1800x1800.jpg?v=1761738584">
      <p style="text-align:center;font-weight:bold;font-size: 12px;">TOP TUBE BAG</p>
    </div>
  `);

        document.querySelector('#toptubebut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_TOP-TUBE-BAG-03_Black_Studio_01_4fdc2dc2-fa6a-4d3d-9478-2fadf600d134_1800x1800.jpg?v=1761738584';

  }
document.getElementById("closeTT")
document.getElementById("closeTT").addEventListener("click", toggleToptubeMain);

  }
  else{
    disposeTopTube();
    visTopTube=!visTopTube;
    showTopTube.style.border="3px solid #e3e3e3";
    removeItem(3);
    subStats(showTopTube.getAttribute("data-vol"),showTopTube.getAttribute("data-price"),showTopTube.getAttribute("data-weight"));
    document.querySelector("#cardTT").remove();
  }

}

var visTopTubel = true;

function toggleToptubel(fromSet=false){
  if(!visTopTube){
    disposeTopTube();
    visTopTube=!visTopTube;
    showTopTube.style.border="3px solid #e3e3e3";
    subStats(showTopTube.getAttribute("data-vol"),showTopTube.getAttribute("data-price"),showTopTube.getAttribute("data-weight"));
 document.querySelector("#cardTT").remove();
  }

   if(!visTopTubeN){
    disposeTopTubeN();
    visTopTubeN=!visTopTubeN;
    showTopTubeN.style.border="3px solid #e3e3e3";
    subStats(showTopTubeN.getAttribute("data-vol"),showTopTubeN.getAttribute("data-price"),showTopTubeN.getAttribute("data-weight"));
    document.querySelector("#cardTTN").remove();
  }

  if(visTopTubel){
     if (!fromSet) KonfigTracking.track('Produkt', 'TOP TUBE LARGE');
    renderToptubel();
    visTopTubel=!visTopTubel;
    showTopTubel.style.border="3px solid black";
    appendItem(showTopTubel.getAttribute("data-"+color),3,3,color);
    addStats(showTopTubel.getAttribute("data-vol"),showTopTubel.getAttribute("data-price"),showTopTubel.getAttribute("data-weight"));

    if(color=="weiß"){
          document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardTTL">
      <button id="closeTTL" class="closecard">-</button>
      <img class="imgCard" src="https://cyclite.cc/cdn/shop/files/CYCLITE_TOP-TUBE-BAG-LARGE-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761737969">
      <p style="text-align:center;font-weight:bold;font-size: 12px;">TOP TUBE BAG LARGE</p>
    </div>
  `);
               document.querySelector('#toptubelbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_TOP-TUBE-BAG-LARGE-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761737969';


}else{

   document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardTTL">
      <button id="closeTTL" class="closecard">-</button>
      <img class="imgCard" src="https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_TOP-TUBE-BAG-LARGE-02_Black_Studio_01_1800x1800.jpg?v=1761737969">
      <p style="text-align:center;font-weight:bold;font-size: 12px;">TOP TUBE BAG LARGE</p>
    </div>
  `);
            document.querySelector('#toptubelbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_TOP-TUBE-BAG-LARGE-02_Black_Studio_01_1800x1800.jpg?v=1761737969';

  }
document.getElementById("closeTTL")
document.getElementById("closeTTL").addEventListener("click", toggleToptubel);

  }
  else{
    disposeToptubel();
    visTopTubel=!visTopTubel;
    showTopTubel.style.border="3px solid #e3e3e3";
    removeItem(3);
    subStats(showTopTubel.getAttribute("data-vol"),showTopTubel.getAttribute("data-price"),showTopTubel.getAttribute("data-weight"));
    
 document.querySelector("#cardTTL").remove();
  }


}


var visTopTubeN = true;

function toggleToptubeN(fromSet=false){
  if(!visTopTube){
    disposeTopTube();
    visTopTube=!visTopTube;
    showTopTube.style.border="3px solid #e3e3e3";
    subStats(showTopTube.getAttribute("data-vol"),showTopTube.getAttribute("data-price"),showTopTube.getAttribute("data-weight"));
 document.querySelector("#cardTT").remove();
  }

    if(!visTopTubel){
    disposeToptubel();
    visTopTubel=!visTopTubel;
    showTopTubel.style.border="3px solid #e3e3e3";
    subStats(showTopTubel.getAttribute("data-vol"),showTopTubel.getAttribute("data-price"),showTopTubel.getAttribute("data-weight"));
    document.querySelector("#cardTTL").remove();
  }

  if(visTopTubeN){
     if (!fromSet) KonfigTracking.track('Produkt', 'TOP TUBE NANO');
    renderToptubeN();
    visTopTubeN=!visTopTubeN;
    showTopTubeN.style.border="3px solid black";
    appendItem(showTopTubeN.getAttribute("data-"+color),3,11,color);
    addStats(showTopTubeN.getAttribute("data-vol"),showTopTubeN.getAttribute("data-price"),showTopTubeN.getAttribute("data-weight"));

    if(color=="weiß"){
        document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardTTN">
      <button id="closeTTN" class="closecard">-</button>
      <img class="imgCard" src="https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_TOP-TUBE-BAG-NANO-01_Light-Grey_Studio_01_1800x1800.jpg?v=1761739505">
      <p style="text-align:center;font-weight:bold;font-size: 12px;">TOP TUBE BAG NANO</p>
    </div>
  `);
               document.querySelector('#toptubenbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_TOP-TUBE-BAG-NANO-01_Light-Grey_Studio_01_1800x1800.jpg?v=1761739505';

  }else{
 
    document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardTTN">
      <button id="closeTTN" class="closecard">-</button>
      <img class="imgCard" src="https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_TOP-TUBE-BAG-NANO-01_Black_Studio_01_1800x1800.jpg?v=1761739505">
      <p style="text-align:center;font-weight:bold;font-size: 12px;">TOP TUBE BAG NANO</p>
    </div>
  `);
            document.querySelector('#toptubenbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_TOP-TUBE-BAG-NANO-01_Black_Studio_01_1800x1800.jpg?v=1761739505';

  }
document.getElementById("closeTTN")
document.getElementById("closeTTN").addEventListener("click", toggleToptubeN);

  }
  else{
    disposeTopTubeN();
    visTopTubeN=!visTopTubeN;
    showTopTubeN.style.border="3px solid #e3e3e3";
    removeItem(3);
    subStats(showTopTubeN.getAttribute("data-vol"),showTopTubeN.getAttribute("data-price"),showTopTubeN.getAttribute("data-weight"));
    
 document.querySelector("#cardTTN").remove();
  }

}


var visFoodpouch = true;

function toggleFoodpouch(e,fromSet = false){
 if (e && typeof e.stopPropagation === "function") {
    e.stopPropagation();
  }
  if(visFoodpouch){
       if (!fromSet) KonfigTracking.track('Produkt', 'FOOD POUCH');
    renderFoodpouch();
    visFoodpouch=!visFoodpouch;
    showFoodpouch.style.border="3px solid black";
    document.getElementById("FPR").style.border="1px solid black";
    appendItem(showFoodpouch.getAttribute("data-"+color),0,8,color);
    addStats(showFoodpouch.getAttribute("data-vol"),showFoodpouch.getAttribute("data-price"),showFoodpouch.getAttribute("data-weight"));

   
    if(color=="weiß"){
    document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardFP">
      <button id="closeFP" class="closecard">-</button>
      <img class="imgCard" src="https://cyclite.cc/cdn/shop/files/CYCLITE_FOOD-POUCH-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761825503">
      <p style="text-align:center;font-weight:bold;font-size: 12px;" id="FPtxt">FOOD POUCH R</p>
    </div>
  `);

                         document.querySelector('#foodpouchbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FOOD-POUCH-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761825503';

  }else{
   document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardFP">
      <button id="closeFP" class="closecard">-</button>
      <img class="imgCard" src="https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FOOD-POUCH-02_Black_Studio_01_1800x1800.jpg?v=1761825503">
      <p style="text-align:center;font-weight:bold;font-size: 12px;" id="FPtxt">FOOD POUCH R</p>
    </div>
  `);
                   document.querySelector('#foodpouchbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FOOD-POUCH-02_Black_Studio_01_1800x1800.jpg?v=1761825503';


  }
document.getElementById("closeFP")
document.getElementById("closeFP").addEventListener("click", toggleFoodpouch);

  
  }
  else{
    disposeFoodpouch();
    visFoodpouch=!visFoodpouch;

    if(visFoodpouchL){
    showFoodpouch.style.border="3px solid #e3e3e3";
    }
    document.getElementById("FPR").style.border="1px solid #e3e3e3";
    removeItem(0);
    subStats(showFoodpouch.getAttribute("data-vol"),showFoodpouch.getAttribute("data-price"),showFoodpouch.getAttribute("data-weight"));
 

    
 

  document.querySelector("#cardFP").remove();


  


  }

}

var visAero = true;

function toggleAero(fromSet=false){

  if(!visHBBN){
      handlebarNanoMesh.dispose();
                     removeItem(4);
                     document.querySelector("#cardHBBN").remove();
                     visHBBN=!visHBBN;    
                    showHBBN.style.border="3px solid #e3e3e3";
   
        subStats(showHBBN.getAttribute("data-vol"),showHBBN.getAttribute("data-price"),showHBBN.getAttribute("data-weight"));


  }

  //Wenn Roll bereits an ist 
 if(!visRoll && visAero ){
    renderAeroRoll();
    disposeRoll();
    visAero = !visAero;
    showAero.style.border="3px solid black";
    appendItem(showAero.getAttribute("data-"+color),4,0,color);
    addStats(showAero.getAttribute("data-vol"),showAero.getAttribute("data-price"),showAero.getAttribute("data-weight"));


    
    if(color=="weiß"){
       document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardAB">
      <button id="closeAB" class="closecard">-</button>
      <img class="imgCard" src="https://cyclite.cc/cdn/shop/files/CYCLITE_HANDLE-BAR-AERO-BAG-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761824211">
      <p style="text-align:center;font-weight:bold;font-size: 12px;">AERO BAG</p>
    </div>
  `);
  document.querySelector('#aerobut .prod-pics').src = 'https://cyclite.cc/cdn/shop/files/CYCLITE_HANDLE-BAR-AERO-BAG-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761824211';
  
  document.querySelector('#rollbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-ROLL-BAG-02_Light-Grey_Studio_01_25f5ae8b-e377-4fc1-b997-a29e042a1a21_1800x1800.jpg?v=1768394306';
  document.querySelector('#cardRB .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-ROLL-BAG-02_Light-Grey_Studio_01_25f5ae8b-e377-4fc1-b997-a29e042a1a21_1800x1800.jpg?v=1768394306';

  }else{
   
     document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardAB">
      <button id="closeAB" class="closecard">-</button>
      <img class="imgCard" src="https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-AERO-BAG-02_Black_Studio_01_1800x1800.jpg?v=1761824211">
      <p style="text-align:center;font-weight:bold;font-size: 12px;">AERO BAG</p>
    </div>
  `);
  document.querySelector('#aerobut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-AERO-BAG-02_Black_Studio_01_1800x1800.jpg?v=1761824211';
 
  document.querySelector('#rollbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-ROLL-BAG-02_Black_Studio_01_353af4b6-2928-45fa-b763-c8e3d0699cfb_1800x1800.jpg?v=1768394306';
  document.querySelector('#cardRB .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-ROLL-BAG-02_Black_Studio_01_353af4b6-2928-45fa-b763-c8e3d0699cfb_1800x1800.jpg?v=1768394306';

  }
document.getElementById("closeAB")
document.getElementById("closeAB").addEventListener("click", toggleAero);

    return;
  } else if (!visRoll && !visAero ){
    disposeAeroRoll();
    visAero=!visAero;
    showAero.style.border="3px solid #e3e3e3";
    renderRoll();
    removeItem(4);
    subStats(showAero.getAttribute("data-vol"),showAero.getAttribute("data-price"),showAero.getAttribute("data-weight"));
 document.querySelector("#cardAB").remove();
    return;
  }

  if(visAero){
    console.log("condition 1");
       if (!fromSet) KonfigTracking.track('Produkt', 'AERO BAG');
    renderAero()
    visAero=!visAero;
    showAero.style.border="3px solid black";
    appendItem(showAero.getAttribute("data-"+color),4,0,color);
    addStats(showAero.getAttribute("data-vol"),showAero.getAttribute("data-price"),showAero.getAttribute("data-weight"));

    if(color=="weiß"){
       document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardAB">
      <button id="closeAB" class="closecard">-</button>
      <img class="imgCard" src="https://cyclite.cc/cdn/shop/files/CYCLITE_HANDLE-BAR-AERO-BAG-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761824211">
      <p style="text-align:center;font-weight:bold;font-size: 12px;">AERO BAG</p>
    </div>
  `);
  document.querySelector('#aerobut .prod-pics').src = 'https://cyclite.cc/cdn/shop/files/CYCLITE_HANDLE-BAR-AERO-BAG-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761824211';

  }else{
   
     document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardAB">
      <button id="closeAB" class="closecard">-</button>
      <img class="imgCard" src="https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-AERO-BAG-02_Black_Studio_01_1800x1800.jpg?v=1761824211">
      <p style="text-align:center;font-weight:bold;font-size: 12px;">AERO BAG</p>
    </div>
  `);
  document.querySelector('#aerobut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-AERO-BAG-02_Black_Studio_01_1800x1800.jpg?v=1761824211';

  }
document.getElementById("closeAB")
document.getElementById("closeAB").addEventListener("click", toggleAero);
 
  }
  else{
    disposeAero();
    visAero=!visAero;
    showAero.style.border="3px solid #e3e3e3";
    removeItem(4);
    subStats(showAero.getAttribute("data-vol"),showAero.getAttribute("data-price"),showAero.getAttribute("data-weight"));
 document.querySelector("#cardAB").remove();
  }

}

var visRoll = true;

function toggleRoll(fromSet=false){

    if(!visHBBN){
      handlebarNanoMesh.dispose();
                     removeItem(4);
                     document.querySelector("#cardHBBN").remove();
                     visHBBN=!visHBBN;    
                    showHBBN.style.border="3px solid #e3e3e3";
   
        subStats(showHBBN.getAttribute("data-vol"),showHBBN.getAttribute("data-price"),showHBBN.getAttribute("data-weight"));


  }

  //wenn Aero bereits an ist 
  if(visRoll && !visAero ){
    renderAeroRoll();
    disposeAero();
    visRoll = !visRoll;
    showRoll.style.border="3px solid black";
    appendItem(showRoll.getAttribute("data-"+color),5,1,color);
    addStats(showRoll.getAttribute("data-vol"),showRoll.getAttribute("data-price"),showRoll.getAttribute("data-weight"));

    

   
    if(color=="weiß"){
       document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardRB">
      <button id="closeRB" class="closecard">-</button>
      <img class="imgCard" src="https://cyclite.cc/cdn/shop/files/CYCLITE_HANDLE-BAR-ROLL-BAG-02_Light-Grey_Studio_01_25f5ae8b-e377-4fc1-b997-a29e042a1a21_1800x1800.jpg?v=1768394306">
      <p style="text-align:center;font-weight:bold;font-size: 12px;">ROLL BAG</p>
    </div>
  `);
  document.querySelector('#aerobut .prod-pics').src = 'https://cyclite.cc/cdn/shop/files/CYCLITE_HANDLE-BAR-AERO-BAG-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761824211';
  
  document.querySelector('#rollbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-ROLL-BAG-02_Light-Grey_Studio_01_25f5ae8b-e377-4fc1-b997-a29e042a1a21_1800x1800.jpg?v=1768394306';
  document.querySelector('#cardRB .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-ROLL-BAG-02_Light-Grey_Studio_01_25f5ae8b-e377-4fc1-b997-a29e042a1a21_1800x1800.jpg?v=1768394306';
  document.querySelector('#cardAB .imgCard').src = 'https://cyclite.cc/cdn/shop/files/CYCLITE_HANDLE-BAR-AERO-BAG-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761824211';

  }else{
 
    document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardRB">
      <button id="closeRB" class="closecard">-</button>
      <img class="imgCard" src="https://cyclite.cc/cdn/shop/files/CYCLITE_HANDLE-BAR-ROLL-BAG-02_Light-Grey_Studio_01_25f5ae8b-e377-4fc1-b997-a29e042a1a21_1800x1800.jpg?v=1768394306">
      <p style="text-align:center;font-weight:bold;font-size: 12px;">ROLL BAG</p>
    </div>
  `);
  document.querySelector('#aerobut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-AERO-BAG-02_Black_Studio_01_1800x1800.jpg?v=1761824211';
 
  document.querySelector('#rollbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-ROLL-BAG-02_Black_Studio_01_353af4b6-2928-45fa-b763-c8e3d0699cfb_1800x1800.jpg?v=1768394306';
  document.querySelector('#cardRB .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-ROLL-BAG-02_Black_Studio_01_353af4b6-2928-45fa-b763-c8e3d0699cfb_1800x1800.jpg?v=1768394306';
  document.querySelector('#cardAB .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-AERO-BAG-02_Black_Studio_01_1800x1800.jpg?v=1761824211';

  }
document.getElementById("closeRB")
document.getElementById("closeRB").addEventListener("click", toggleRoll);

    return;
    //Wenn Aeroroll an ist, und roll ausgemacht wird
  } else if (!visRoll && !visAero ){
    disposeAeroRoll();
    visRoll=!visRoll;
    showRoll.style.border="3px solid #e3e3e3";
    renderAero();
    removeItem(5);
    subStats(showRoll.getAttribute("data-vol"),showRoll.getAttribute("data-price"),showRoll.getAttribute("data-weight"));
document.querySelector("#cardRB").remove();

    return;
  } 
  if(visRoll){
   if (!fromSet) KonfigTracking.track('Produkt', 'ROLL BAG');
    renderRoll();
    visRoll=!visRoll;
    showRoll.style.border="3px solid black";
    appendItem(showRoll.getAttribute("data-"+color),5,1,color);
    addStats(showRoll.getAttribute("data-vol"),showRoll.getAttribute("data-price"),showRoll.getAttribute("data-weight"));

    if(color=="weiß"){
     document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardRB">
      <button id="closeRB" class="closecard">-</button>
      <img class="imgCard" src="https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-ROLL-BAG-02_Light-Grey_Studio_01_25f5ae8b-e377-4fc1-b997-a29e042a1a21_1800x1800.jpg?v=1768394306">
      <p style="text-align:center;font-weight:bold;font-size: 12px;">ROLL BAG</p>
    </div>
  `);
  document.querySelector('#rollbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-ROLL-BAG-02_Light-Grey_Studio_01_25f5ae8b-e377-4fc1-b997-a29e042a1a21_1800x1800.jpg?v=1768394306';

  }else{
   document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardRB">
      <button id="closeRB" class="closecard">-</button>
      <img class="imgCard" src="https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-ROLL-BAG-02_Black_Studio_01_353af4b6-2928-45fa-b763-c8e3d0699cfb_1800x1800.jpg?v=1768394306">
      <p style="text-align:center;font-weight:bold;font-size: 12px;">ROLL BAG</p>
    </div>
  `);
  document.querySelector('#rollbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-ROLL-BAG-02_Black_Studio_01_353af4b6-2928-45fa-b763-c8e3d0699cfb_1800x1800.jpg?v=1768394306';


  }
document.getElementById("closeRB")
document.getElementById("closeRB").addEventListener("click", toggleRoll);

    return;
  }
  else{
    disposeRoll();
    visRoll=!visRoll;
    showRoll.style.border="3px solid #e3e3e3";
    removeItem(5);
    subStats(showRoll.getAttribute("data-vol"),showRoll.getAttribute("data-price"),showRoll.getAttribute("data-weight"));

 document.querySelector("#cardRB").remove();
  }

}


/*
var saddleSmallCol = document.getElementById("sadds")
saddleSmallCol.addEventListener("change",chooseColSS);
*/
document.querySelectorAll(".colorSaddleS").forEach(el => el.addEventListener("click", colSaddleS));

function colSaddleS(e){
color = $(this).val();
   e.stopPropagation(); 

   if(visSaddleSmall){
    toggleSaddleSmallMain();
   }

changeSaddlebagSmall($(this).val());
     appendItem(showSaddleS.getAttribute("data-"+color),1,7,color);

             $(".colorSaddleS").css({
 "outline": "none"
});

  $(this).css({
  "outline": "1px solid black"
});

if($(this).val()=="schwarz"){
  KonfigTracking.track('Farbe', 'Black');
     if(locale=="de"){
  document.getElementById("colortextSBs").innerHTML='<br>Farbe: Black';
   }else if (locale=="en"){
  document.getElementById("colortextSBs").innerHTML='<br>Color: Black';
   }else if(locale=="fr"){
      document.getElementById("colortextSBs").innerHTML='<br>couler: Black';

   }
 

   document.querySelector('#saddlebagsbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_SADDLE-BAG-SMALL-02_Black_Studio_01_1800x1800.jpg?v=1761827654';

   document.querySelector('#cardSBS .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_SADDLE-BAG-SMALL-02_Black_Studio_01_1800x1800.jpg?v=1761827654';

}else{
  KonfigTracking.track('Farbe', 'Lightgrey');
    if(locale=="de"){
  document.getElementById("colortextSBs").innerHTML='<br>Farbe: Lightgrey';
   }else if (locale=="en"){
  document.getElementById("colortextSBs").innerHTML='<br>Color: Lightgrey';
   }else if(locale=="fr"){
      document.getElementById("colortextSBs").innerHTML='<br>couler: Lightgrey';

   }
      document.querySelector('#saddlebagsbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_SADDLE-BAG-SMALL-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761827654';

 document.querySelector('#cardSBS .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_SADDLE-BAG-SMALL-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761827654';

}

}
    
/////

document.querySelectorAll(".colorSaddleN").forEach(el => el.addEventListener("click", colSaddleN));

function colSaddleN(e){
color = $(this).val();
   e.stopPropagation();
   
   if(visSaddlebagN){
    toggleSaddleNano();
   } 
   
   changeSaddlebagNano($(this).val());

     appendItem(showSaddleN.getAttribute("data-"+color),1,12,color);

             $(".colorSaddleN").css({
 "outline": "none"
});

  $(this).css({
  "outline": "1px solid black"
});

if($(this).val()=="schwarz"){
  KonfigTracking.track('Farbe', 'Black');
     if(locale=="de"){
  document.getElementById("colortextSBn").innerHTML='<br>Farbe: Black';
   }else if (locale=="en"){
  document.getElementById("colortextSBn").innerHTML='<br>Color: Black';
   }else if(locale=="fr"){
      document.getElementById("colortextSBn").innerHTML='<br>couler: Black';

   }
 

   document.querySelector('#saddlebagnbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_SADDLE-BAG-NANO-01_Black_Studio_02_1800x1800.jpg?v=1761827081';

   document.querySelector('#cardSBN .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_SADDLE-BAG-NANO-01_Black_Studio_02_1800x1800.jpg?v=1761827081';

}else{
  KonfigTracking.track('Farbe', 'Lightgrey');
    if(locale=="de"){
  document.getElementById("colortextSBn").innerHTML='<br>Farbe: Lightgrey';
   }else if (locale=="en"){
  document.getElementById("colortextSBn").innerHTML='<br>Color: Lightgrey';
   }else if(locale=="fr"){
      document.getElementById("colortextSBn").innerHTML='<br>couler: Lightgrey';

   }
      document.querySelector('#saddlebagnbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_SADDLE-BAG-NANO-01_Light-Grey_Studio_01_1800x1800.jpg?v=1761827081';

 document.querySelector('#cardSBN .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_SADDLE-BAG-NANO-01_Light-Grey_Studio_01_1800x1800.jpg?v=1761827081';

}

}


///
/*
var framebagCol = document.getElementById("frabCol")
frabCol.addEventListener("change",chooseFraBCol);
*/

document.querySelectorAll(".colorFB").forEach(el => el.addEventListener("click", colFramebag));


function colFramebag(e){
  color = $(this).val();
e.stopPropagation(); 

if(visFramebag){
  toggleframebagMain();
}

  changeFramebag($(this).val());
  appendItem(showFramebag.getAttribute("data-"+color),2,4,color);

          $(".colorFB").css({
 "outline": "none"
});

  $(this).css({
  "outline": "1px solid black"
});

if($(this).val()=="schwarz"){
  KonfigTracking.track('Farbe', 'Black');
     if(locale=="de"){
  document.getElementById("colortextFB").innerHTML='<br>Farbe: Black';
   }else if (locale=="en"){
  document.getElementById("colortextFB").innerHTML='<br>Color: Black';
   }else if(locale=="fr"){
      document.getElementById("colortextFB").innerHTML='<br>couler: Black';

   }

         document.querySelector('#framebagbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FRAME-BAG-03_Black_Studio_01_720x.jpg?v=1765864945';

   document.querySelector('#cardFB .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FRAME-BAG-03_Black_Studio_01_720x.jpg?v=1765864945';

}else{
  KonfigTracking.track('Farbe', 'Lightgrey');
      if(locale=="de"){
  document.getElementById("colortextFB").innerHTML='<br>Farbe: Lightgrey';
   }else if (locale=="en"){
  document.getElementById("colortextFB").innerHTML='<br>Color: Lightgrey';
   }else if(locale=="fr"){
      document.getElementById("colortextFB").innerHTML='<br>couler: Lightgrey';

   }
            document.querySelector('#framebagbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FRAME-BAG-03_Light_grey_Studio_01_1800x1800.jpg?v=1765864945';

 document.querySelector('#cardFB .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FRAME-BAG-03_Light_grey_Studio_01_1800x1800.jpg?v=1765864945';

}

}



document.querySelectorAll(".colorFoB").forEach(el => el.addEventListener("click", colForkbag));

/*
function colForkbag(e){
  color = $(this).val();
e.stopPropagation(); 

if(visForkbagR){

  toggleForkbagR();
}
  changeForkbagR($(this).val());
  appendItem(showFramebag.getAttribute("data-"+color),6,14,color);

          $(".colorFB").css({
 "outline": "none"
});

  $(this).css({
  "outline": "1px solid black"
});

if($(this).val()=="schwarz"){
     if(locale=="de"){
  document.getElementById("colortextFoB").innerHTML='<br>Farbe: Black';
   }else if (locale=="en"){
  document.getElementById("colortextFoB").innerHTML='<br>Color: Black';
   }else if(locale=="fr"){
      document.getElementById("colortextFoB").innerHTML='<br>couler: Black';

   }

         document.querySelector('#forkbagbut .prod-pics').src = 'https://kouv8jiwdeqin0c7-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FORK-BAG-01_Black_Studio_03.jpg?v=1761737650&width=1400';

   document.querySelector('#cardFoB .imgCard').src = 'https://kouv8jiwdeqin0c7-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FORK-BAG-01_Black_Studio_03.jpg?v=1761737650&width=1400';

}else{
      if(locale=="de"){
  document.getElementById("colortextFoB").innerHTML='<br>Farbe: Lightgrey';
   }else if (locale=="en"){
  document.getElementById("colortextFoB").innerHTML='<br>Color: Lightgrey';
   }else if(locale=="fr"){
      document.getElementById("colortextFoB").innerHTML='<br>couler: Lightgrey';

   }
            document.querySelector('#forkbagbut .prod-pics').src = 'https://kouv8jiwdeqin0c7-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FORK-BAG-01_Light-Grey_Studio_04.jpg?v=1761737650&width=1400';

 document.querySelector('#cardFoB .imgCard').src = 'https://kouv8jiwdeqin0c7-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FORK-BAG-01_Light-Grey_Studio_04.jpg?v=1761737650&width=1400';

}

}
*/

function colForkbag(e){
  color = $(this).val();
    e.stopPropagation();

 

    if(!visForkbagR){
  changeForkbagR($(this).val());
appendItem(showForkbag.getAttribute("data-"+color+"R"),6,14,color);
  if($(this).val()=="schwarz"){

                   document.querySelector('#forkbagbut .prod-pics').src = 'https://kouv8jiwdeqin0c7-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FORK-BAG-01_Black_Studio_03.jpg?v=1761737650&width=1400';
       document.querySelector('#cardFoB .imgCard').src = 'https://kouv8jiwdeqin0c7-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FORK-BAG-01_Black_Studio_03.jpg?v=1761737650&width=1400';

  }else{
                       document.querySelector('#forkbagbut .prod-pics').src = 'https://kouv8jiwdeqin0c7-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FORK-BAG-01_Light-Grey_Studio_04.jpg?v=1761737650&width=1400';

             document.querySelector('#cardFoB .imgCard').src = 'https://kouv8jiwdeqin0c7-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FORK-BAG-01_Light-Grey_Studio_04.jpg?v=1761737650&width=1400';

  }

    }
    if(!visForkbagL){
        changeForkbagL($(this).val());

        appendItem(showForkbag.getAttribute("data-"+color+"L"),7,14);
   if($(this).val()=="schwarz"){

                   document.querySelector('#forkbagbut .prod-pics').src = 'https://kouv8jiwdeqin0c7-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FORK-BAG-01_Black_Studio_03.jpg?v=1761737650&width=1400';
       document.querySelector('#cardFoBL .imgCard').src = 'https://kouv8jiwdeqin0c7-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FORK-BAG-01_Black_Studio_03.jpg?v=1761737650&width=1400';

  }else{
                       document.querySelector('#forkbagbut .prod-pics').src = 'https://kouv8jiwdeqin0c7-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FORK-BAG-01_Light-Grey_Studio_04.jpg?v=1761737650&width=1400';

             document.querySelector('#cardFoBL .imgCard').src = 'https://kouv8jiwdeqin0c7-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FORK-BAG-01_Light-Grey_Studio_04.jpg?v=1761737650&width=1400';

  }
    }
  

    $(".colorFoB").css({
 "outline": "none"
});

  $(this).css({
  "outline": "1px solid black"
});

if($(this).val()=="schwarz"){
  KonfigTracking.track('Farbe', 'Black');
     if(locale=="de"){
  document.getElementById("colortextFoB").innerHTML='<br>Farbe: Black';
   }else if (locale=="en"){
  document.getElementById("colortextFoB").innerHTML='<br>Color: Black';
   }else if(locale=="fr"){
      document.getElementById("colortextFoB").innerHTML='<br>couler: Black';

   }
   

}else{
  KonfigTracking.track('Farbe', 'Lightgrey');
  if(locale=="de"){
  document.getElementById("colortextFoB").innerHTML='<br>Farbe: Lightgrey';
   }else if (locale=="en"){
  document.getElementById("colortextFoB").innerHTML='<br>Color: Lightgrey';
   }else if(locale=="fr"){
      document.getElementById("colortextFoB").innerHTML='<br>couler: Lightgrey';

   }

}

}

//

//FramebagL

/*
var framebaglCol = document.getElementById("framebagL")
framebaglCol.addEventListener("change",chooseFraBlCol);
*/
document.querySelectorAll(".colorFBL").forEach(el => el.addEventListener("click", colFramebagL));

function colFramebagL(e){
  color = $(this).val();
 e.stopPropagation(); 

 if(visFramebagl){
  toggleframebaglMain();
 }

  changeFramebagl($(this).val());
  appendItem(showFramebagl.getAttribute("data-"+color),2,5,color);

        $(".colorFBL").css({
 "outline": "none"
});

  $(this).css({
  "outline": "1px solid black"
});

if($(this).val()=="schwarz"){
  KonfigTracking.track('Farbe', 'Black');
       if(locale=="de"){
  document.getElementById("colortextFBL").innerHTML='<br>Farbe: Black';
   }else if (locale=="en"){
  document.getElementById("colortextFBL").innerHTML='<br>Color: Black';
   }else if(locale=="fr"){
      document.getElementById("colortextFBL").innerHTML='<br>couler: Black';

   }

               document.querySelector('#framebaglbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FRAME-BAG-LARGE-02_Black_Studo_01_1800x1800.jpg?v=1761737018';

 document.querySelector('#cardFBL .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FRAME-BAG-LARGE-02_Black_Studo_01_1800x1800.jpg?v=1761737018';

}else{
  KonfigTracking.track('Farbe', 'Lightgrey');
    if(locale=="de"){
  document.getElementById("colortextFBL").innerHTML='<br>Farbe: Lightgrey';
   }else if (locale=="en"){
  document.getElementById("colortextFBL").innerHTML='<br>Color: Lightgrey';
   }else if(locale=="fr"){
      document.getElementById("colortextFBL").innerHTML='<br>couler: Lightgrey';

   }

               document.querySelector('#framebaglbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FRAME-BAG-LARGE-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761737018';

 document.querySelector('#cardFBL .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FRAME-BAG-LARGE-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761737018';

}
}

document.querySelectorAll(".colorFBXT").forEach(el => el.addEventListener("click", colFramebagXT));

function colFramebagXT(e){
  color = $(this).val();
 e.stopPropagation(); 

 if(visFramebagXT){
  toggleFramebagXT();
 }

  changeFramebagXT($(this).val());
   appendItem(showFramebagXT.getAttribute("data-"+color),2,9,color);

         $(".colorFBXT").css({
 "outline": "none"
});

  $(this).css({
  "outline": "1px solid black"
});

if($(this).val()=="schwarz"){
  KonfigTracking.track('Farbe', 'Black');
     if(locale=="de"){
  document.getElementById("colortextFBXT").innerHTML='<br>Farbe: Black';
   }else if (locale=="en"){
  document.getElementById("colortextFBXT").innerHTML='<br>Color: Black';
   }else if(locale=="fr"){
      document.getElementById("colortextFBXT").innerHTML='<br>couler: Black';

   }

                  document.querySelector('#framebagxtbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FRAME-BAG-XT-02_Black_Studio_01_82165cac-6a56-4d9d-8807-8e1ef6a9ffd0_1800x1800.jpg?v=1761739026';

 document.querySelector('#cardFBXT .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FRAME-BAG-XT-02_Black_Studio_01_82165cac-6a56-4d9d-8807-8e1ef6a9ffd0_1800x1800.jpg?v=1761739026';

}else{
  KonfigTracking.track('Farbe', 'Lightgrey');
  if(locale=="de"){
  document.getElementById("colortextFBXT").innerHTML='<br>Farbe: Lightgrey';
   }else if (locale=="en"){
  document.getElementById("colortextFBXT").innerHTML='<br>Color: Lightgrey';
   }else if(locale=="fr"){
      document.getElementById("colortextFBXT").innerHTML='<br>couler: Lightgrey';

   }

                  document.querySelector('#framebagxtbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FRAME-BAG-XT-02_Light-Grey_01_15302eb5-672d-4a84-8e9a-71372852a12b_1800x1800.jpg?v=1761739026';

 document.querySelector('#cardFBXT .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FRAME-BAG-XT-02_Light-Grey_01_15302eb5-672d-4a84-8e9a-71372852a12b_1800x1800.jpg?v=1761739026';

}
}

document.querySelectorAll(".colorFBS").forEach(el => el.addEventListener("click", colFramebagS));

function colFramebagS(e){
  color = $(this).val();
 e.stopPropagation(); 

 if(visFramebagSmall){
  toggleFramebagSmall();
 }

  changeFramebagSmall($(this).val());
   appendItem(showFramebagSmall.getAttribute("data-"+color),2,10,color);

         $(".colorFBS").css({
 "outline": "none"
});

  $(this).css({
  "outline": "1px solid black"
});

if($(this).val()=="schwarz"){
  KonfigTracking.track('Farbe', 'Black');
     if(locale=="de"){
  document.getElementById("colortextFBS").innerHTML='<br>Farbe: Black';
   }else if (locale=="en"){
  document.getElementById("colortextFBS").innerHTML='<br>Color: Black';
   }else if(locale=="fr"){
      document.getElementById("colortextFBS").innerHTML='<br>couler: Black';

   }

                     document.querySelector('#framebagsmallbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FRAME-BAG-SMALL-02_Black_Studio_01_1800x1800.jpg?v=1761837246';

    document.querySelector('#cardFBS .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FRAME-BAG-SMALL-02_Black_Studio_01_1800x1800.jpg?v=1761837246';


}else{
  KonfigTracking.track('Farbe', 'Lightgrey');
   if(locale=="de"){
  document.getElementById("colortextFBS").innerHTML='<br>Farbe: Lightgrey';
   }else if (locale=="en"){
  document.getElementById("colortextFBS").innerHTML='<br>Color: Lightgrey';
   }else if(locale=="fr"){
      document.getElementById("colortextFBS").innerHTML='<br>couler: Lightgrey';

   }

                     document.querySelector('#framebagsmallbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FRAME-BAG-SMALL-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761837246';

  document.querySelector('#cardFBS .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FRAME-BAG-SMALL-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761837246';


}
}


///
function selectVariant(mesh, variant) {
  BABYLON.GLTF2.Loader.Extensions.KHR_materials_variants.SelectVariant(mesh, variant);
}


// funktion um Farbe zu wechseln
/*
var saddleCol = document.getElementById("sadd")
saddleCol.addEventListener("change",colSaddle);
*/
document.querySelectorAll(".colorSaddle").forEach(el => el.addEventListener("click", colSaddle));

function colSaddle(e){
  color = $(this).val();
  /*
  if(visSaddlebag==false){
  items[2]=saddleCol.options[saddleCol.selectedIndex].value.split(',')[1];
  changeSaddlebag(saddleCol.options[saddleCol.selectedIndex].value.split(',')[0]);}
*/
  e.stopPropagation(); 

  if(visSaddlebag){
    toggleSaddleMain();
  }
  changeSaddlebag($(this).val());
  appendItem(showSaddlebag.getAttribute("data-"+color),1,6,color);


      $(".colorSaddle").css({
 "outline": "none"
});

  $(this).css({
  "outline": "1px solid black"
});

if($(this).val()=="schwarz"){
  KonfigTracking.track('Farbe', 'Black');
    if(locale=="de"){
  document.getElementById("colortextSB").innerHTML='<br>Farbe: Black';
   }else if (locale=="en"){
  document.getElementById("colortextSB").innerHTML='<br>Color: Black';
   }else if(locale=="fr"){
      document.getElementById("colortextSB").innerHTML='<br>couler: Black';

   }

                        document.querySelector('#saddlebagbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_SADDLE-BAG-02_Black_Studio_01_1800x1800.jpg?v=1761739753';
   document.querySelector('#cardSB .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_SADDLE-BAG-02_Black_Studio_01_1800x1800.jpg?v=1761739753';


}else{
  KonfigTracking.track('Farbe', 'Lightgrey');
  if(locale=="de"){
  document.getElementById("colortextSB").innerHTML='<br>Farbe: Lightgrey';
   }else if (locale=="en"){
  document.getElementById("colortextSB").innerHTML='<br>Color: Lightgrey';
   }else if(locale=="fr"){
      document.getElementById("colortextSB").innerHTML='<br>couler: Lightgrey';

   }
   document.querySelector('#saddlebagbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_SADDLE-BAG-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761739753';
 document.querySelector('#cardSB .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_SADDLE-BAG-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761739753';


}

}

         
/*
var toptubeCol = document.getElementById("toptubecol")
toptubeCol.addEventListener("change",colToptube);
*/

document.querySelectorAll(".colorToptube").forEach(el => el.addEventListener("click", colToptube));


function colToptube(e){
  color = $(this).val();
  e.stopPropagation(); 

  if(visTopTube){
      toggleToptubeMain();
      }

  changeToptube($(this).val());
    appendItem(showTopTube.getAttribute("data-"+color),3,2,color);


      $(".colorToptube").css({
 "outline": "none"
});

  $(this).css({
  "outline": "1px solid black"
});

if($(this).val()=="schwarz"){
  KonfigTracking.track('Farbe', 'Black');
     if(locale=="de"){
  document.getElementById("colortextTT").innerHTML='<br>Farbe: Black';
   }else if (locale=="en"){
  document.getElementById("colortextTT").innerHTML='<br>Color: Black';
   }else if(locale=="fr"){
      document.getElementById("colortextTT").innerHTML='<br>couler: Black';

   }

      document.querySelector('#toptubebut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_TOP-TUBE-BAG-03_Black_Studio_01_4fdc2dc2-fa6a-4d3d-9478-2fadf600d134_1800x1800.jpg?v=1761738584';

    document.querySelector('#cardTT .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_TOP-TUBE-BAG-03_Black_Studio_01_4fdc2dc2-fa6a-4d3d-9478-2fadf600d134_1800x1800.jpg?v=1761738584';


}else{
  KonfigTracking.track('Farbe', 'Lightgrey');
   if(locale=="de"){
  document.getElementById("colortextTT").innerHTML='<br>Farbe: Lightgrey';
   }else if (locale=="en"){
  document.getElementById("colortextTT").innerHTML='<br>Color: Lightgrey';
   }else if(locale=="fr"){
      document.getElementById("colortextTT").innerHTML='<br>couler: Lightgrey';

   }

         document.querySelector('#toptubebut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_TOP-TUBE-BAG-03_Light-Grey_Studio_01_88bcc662-44c0-4558-9363-beed1327eb9c_1800x1800.jpg?v=1761738584';

  document.querySelector('#cardTT .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_TOP-TUBE-BAG-03_Light-Grey_Studio_01_88bcc662-44c0-4558-9363-beed1327eb9c_1800x1800.jpg?v=1761738584';


}

console.log(formData);
}
/*
var toptubelCol = document.getElementById("toptubelcol")
toptubelCol.addEventListener("change",colToptubel);
*/

document.querySelectorAll(".colorToptubeL").forEach(el => el.addEventListener("click", colToptubel));

function colToptubel(e){
  color = $(this).val();
  e.stopPropagation(); 

    if(visTopTubel){
  toggleToptubel();
      }

  changeToptubel($(this).val());
  appendItem(showTopTubel.getAttribute("data-"+color),3,3,color);

      $(".colorToptubeL").css({
 "outline": "none"
});

  $(this).css({
  "outline": "1px solid black"
});

if($(this).val()=="schwarz"){
  KonfigTracking.track('Farbe', 'Black');
     if(locale=="de"){
  document.getElementById("colortextTTL").innerHTML='<br>Farbe: Black';
   }else if (locale=="en"){
  document.getElementById("colortextTTL").innerHTML='<br>Color: Black';
   }else if(locale=="fr"){
      document.getElementById("colortextTTL").innerHTML='<br>couler: Black';

   }

            document.querySelector('#toptubelbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_TOP-TUBE-BAG-LARGE-02_Black_Studio_01_1800x1800.jpg?v=1761737969';

     document.querySelector('#cardTTL .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_TOP-TUBE-BAG-LARGE-02_Black_Studio_01_1800x1800.jpg?v=1761737969';


}else{
  KonfigTracking.track('Farbe', 'Lightgrey');
  if(locale=="de"){
  document.getElementById("colortextTTL").innerHTML='<br>Farbe: Lightgrey';
   }else if (locale=="en"){
  document.getElementById("colortextTTL").innerHTML='<br>Color: Lightgrey';
   }else if(locale=="fr"){
      document.getElementById("colortextTTL").innerHTML='<br>couler: Lightgrey';

   }

               document.querySelector('#toptubelbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_TOP-TUBE-BAG-LARGE-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761737969';

   document.querySelector('#cardTTL .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_TOP-TUBE-BAG-LARGE-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761737969';

  

}
}


document.querySelectorAll(".colorTopTubeN").forEach(el => el.addEventListener("click", colToptubeN));

function colToptubeN(e){
  color = $(this).val();
  e.stopPropagation(); 

  if(visTopTubeN){
    toggleToptubeN();
  }
  changeToptubeN($(this).val());
  appendItem(showTopTubeN.getAttribute("data-"+color),3,11,color);

      $(".colorTopTubeN").css({
 "outline": "none"
});

  $(this).css({
  "outline": "1px solid black"
});

if($(this).val()=="schwarz"){
  KonfigTracking.track('Farbe', 'Black');
     if(locale=="de"){
  document.getElementById("colortextTTN").innerHTML='<br>Farbe: Black';
   }else if (locale=="en"){
  document.getElementById("colortextTTN").innerHTML='<br>Color: Black';
   }else if(locale=="fr"){
      document.getElementById("colortextTTN").innerHTML='<br>couler: Black';

   }

            document.querySelector('#toptubenbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_TOP-TUBE-BAG-NANO-01_Black_Studio_01_1800x1800.jpg?v=1761739505';

     document.querySelector('#cardTTN .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_TOP-TUBE-BAG-NANO-01_Black_Studio_01_1800x1800.jpg?v=1761739505';


}else{
  KonfigTracking.track('Farbe', 'Lightgrey');
  if(locale=="de"){
  document.getElementById("colortextTTN").innerHTML='<br>Farbe: Lightgrey';
   }else if (locale=="en"){
  document.getElementById("colortextTTN").innerHTML='<br>Color: Lightgrey';
   }else if(locale=="fr"){
      document.getElementById("colortextTTN").innerHTML='<br>couler: Lightgrey';

   }

               document.querySelector('#toptubenbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_TOP-TUBE-BAG-NANO-01_Light-Grey_Studio_01_1800x1800.jpg?v=1761739505';

   document.querySelector('#cardTTN .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_TOP-TUBE-BAG-NANO-01_Light-Grey_Studio_01_1800x1800.jpg?v=1761739505';

  

}
}


//

document.querySelectorAll(".colorHBBN").forEach(el => el.addEventListener("click", colHBBN));

function colHBBN(e){
  color = $(this).val();
  e.stopPropagation(); 

  if(visHBBN){
    toggleHBBN();
  }

  changeHBBN($(this).val());
  appendItem(showTopTubeN.getAttribute("data-"+color),4,13,color);

      $(".colorHBBN").css({
 "outline": "none"
});

  $(this).css({
  "outline": "1px solid black"
});

if($(this).val()=="schwarz"){
  KonfigTracking.track('Farbe', 'Black');
     if(locale=="de"){
  document.getElementById("colortextHBBN").innerHTML='<br>Farbe: Black';
   }else if (locale=="en"){
  document.getElementById("colortextHBBN").innerHTML='<br>Color: Black';
   }else if(locale=="fr"){
      document.getElementById("colortextHBBN").innerHTML='<br>couler: Black';

   }

            document.querySelector('#handlebarnbut .prod-pics').src = 'https://9k186x5y31hjh0cf-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-BAG-NANO-01_Black_Studio_01_1800x1800.jpg?v=1761825334';

     document.querySelector('#cardHBBN .imgCard').src = 'https://9k186x5y31hjh0cf-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-BAG-NANO-01_Black_Studio_01_1800x1800.jpg?v=1761825334';


}else{
  KonfigTracking.track('Farbe', 'Lightgrey');
  if(locale=="de"){
  document.getElementById("colortextHBBN").innerHTML='<br>Farbe: Lightgrey';
   }else if (locale=="en"){
  document.getElementById("colortextHBBN").innerHTML='<br>Color: Lightgrey';
   }else if(locale=="fr"){
      document.getElementById("colortextHBBN").innerHTML='<br>couler: Lightgrey';

   }

               document.querySelector('#handlebarnbut .prod-pics').src = 'https://9k186x5y31hjh0cf-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-BAG-NANO-01_Light-Grey_Studio_01_1800x1800.jpg?v=1761825334';

   document.querySelector('#cardHBBN .imgCard').src = 'https://9k186x5y31hjh0cf-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-BAG-NANO-01_Light-Grey_Studio_01_1800x1800.jpg?v=1761825334';

  

}
}

//


/*
var pouchCol = document.getElementById("pouchcol")
pouchCol.addEventListener("change",colpouch);
*/

document.querySelectorAll(".colorFP").forEach(el => el.addEventListener("click", colpouch));

function colpouch(e){
  color = $(this).val();
    e.stopPropagation();

 

    if(!visFoodpouch){
  changepouch($(this).val());
appendItem(showFoodpouch.getAttribute("data-"+color),0,8,color);
  if($(this).val()=="schwarz"){

                   document.querySelector('#foodpouchbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FOOD-POUCH-02_Black_Studio_01_1800x1800.jpg?v=1761825503';
       document.querySelector('#cardFP .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FOOD-POUCH-02_Black_Studio_01_1800x1800.jpg?v=1761825503';

  }else{
                       document.querySelector('#foodpouchbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FOOD-POUCH-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761825503';

             document.querySelector('#cardFP .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FOOD-POUCH-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761825503';

  }

    }
    if(!visFoodpouchL){
        changepouchL($(this).val());
        appendItem(showFoodpouch.getAttribute("data-"+color),7,8,color);
        
  if($(this).val()=="schwarz"){
                       document.querySelector('#foodpouchbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FOOD-POUCH-02_Black_Studio_01_1800x1800.jpg?v=1761825503';

       document.querySelector('#cardFPL .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FOOD-POUCH-02_Black_Studio_01_1800x1800.jpg?v=1761825503';

  }else{
document.querySelector('#foodpouchbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FOOD-POUCH-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761825503';
             document.querySelector('#cardFPL .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FOOD-POUCH-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761825503';

  }
    }
  

    $(".colorFP").css({
 "outline": "none"
});

  $(this).css({
  "outline": "1px solid black"
});

if($(this).val()=="schwarz"){
  KonfigTracking.track('Farbe', 'Black');
     if(locale=="de"){
  document.getElementById("colortextFP").innerHTML='<br>Farbe: Black';
   }else if (locale=="en"){
  document.getElementById("colortextFP").innerHTML='<br>Color: Black';
   }else if(locale=="fr"){
      document.getElementById("colortextFP").innerHTML='<br>couler: Black';

   }
   

}else{
  KonfigTracking.track('Farbe', 'Lightgrey');
  if(locale=="de"){
  document.getElementById("colortextFP").innerHTML='<br>Farbe: Lightgrey';
   }else if (locale=="en"){
  document.getElementById("colortextFP").innerHTML='<br>Color: Lightgrey';
   }else if(locale=="fr"){
      document.getElementById("colortextFP").innerHTML='<br>couler: Lightgrey';

   }

}

}

//







/*
var aeroCol = document.getElementById("aerocol")
aeroCol.addEventListener("change",colAero);
*/

document.querySelectorAll(".colorAero").forEach(el => el.addEventListener("click", colAero));
function colAero(e){
  color = $(this).val();
   e.stopPropagation();



     if(!visAero&&!visRoll){
    changeAeroRoll(color);
      appendItem(showRoll.getAttribute("data-"+color),5,1,color);
        appendItem(showAero.getAttribute("data-"+color),4,0,color);

        if($(this).val()=="schwarz"){
    document.querySelector('#aerobut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-AERO-BAG-02_Black_Studio_01_1800x1800.jpg?v=1761824211';

    document.querySelector('#rollbut .prod-pics').src ='https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-ROLL-BAG-02_Black_Studio_01_353af4b6-2928-45fa-b763-c8e3d0699cfb_1800x1800.jpg?v=1768394306';

     document.querySelector('#cardAB .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-AERO-BAG-02_Black_Studio_01_1800x1800.jpg?v=1761824211';
     document.querySelector('#cardRB .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-ROLL-BAG-02_Black_Studio_01_353af4b6-2928-45fa-b763-c8e3d0699cfb_1800x1800.jpg?v=1768394306';

        }else{

              document.querySelector('#aerobut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-AERO-BAG-02_Light-Grey_Studio_01_720x.jpg?v=1761824211';
    document.querySelector('#rollbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-ROLL-BAG-02_Light-Grey_Studio_01_25f5ae8b-e377-4fc1-b997-a29e042a1a21_1800x1800.jpg?v=1768394306';


               document.querySelector('#cardAB .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-AERO-BAG-02_Light-Grey_Studio_01_720x.jpg?v=1761824211';
                document.querySelector('#cardRB .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-ROLL-BAG-02_Light-Grey_Studio_01_25f5ae8b-e377-4fc1-b997-a29e042a1a21_1800x1800.jpg?v=1768394306';


        }

  }else{

     if(visAero){
      console.log("chcked 1");
      toggleAero();}

      
    changeAero($(this).val());
  appendItem(showAero.getAttribute("data-"+color),4,0,color);
   


  }

  $(".colorAero").css({
 "outline": "none"
});

  $(this).css({
  "outline": "1px solid black"
});

if($(this).val()=="schwarz"){
KonfigTracking.track('Farbe', 'Black');
    if(locale=="de"){
     document.getElementById("colortextAB").innerHTML='<br>Farbe: Black';
document.getElementById("colortextRB").innerHTML='<br>Farbe: Black';
   }else if (locale=="en"){
  document.getElementById("colortextAB").innerHTML='<br>Color: Black';
document.getElementById("colortextRB").innerHTML='<br>Color: Black';
   }else if(locale=="fr"){
      document.getElementById("colortextAB").innerHTML='<br>couler: Black';
document.getElementById("colortextRB").innerHTML='<br>couler: Black';

   }

              document.querySelector('#aerobut .prod-pics').src =  'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-AERO-BAG-02_Black_Studio_01_1800x1800.jpg?v=1761824211';

     document.querySelector('#cardAB .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-AERO-BAG-02_Black_Studio_01_1800x1800.jpg?v=1761824211';




   $('.colorRoll[value="weiß"]').css({
  outline: "none"
});
$('.colorRoll[value="schwarz"]').css({
  outline: "1px solid black"
});


}else{
  KonfigTracking.track('Farbe', 'Lightgrey');
 if(locale=="de"){
     document.getElementById("colortextAB").innerHTML='<br>Farbe: Lightgrey';
document.getElementById("colortextRB").innerHTML='<br>Farbe: Lightgrey';
   }else if (locale=="en"){
  document.getElementById("colortextAB").innerHTML='<br>Color: Lightgrey';
document.getElementById("colortextRB").innerHTML='<br>Color: Lightgrey';
   }else if(locale=="fr"){
      document.getElementById("colortextAB").innerHTML='<br>couler: Lightgrey';
document.getElementById("colortextRB").innerHTML='<br>couler: Lightgrey';

   }

                 document.querySelector('#aerobut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-AERO-BAG-02_Light-Grey_Studio_01_720x.jpg?v=1761824211';

               document.querySelector('#cardAB .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-AERO-BAG-02_Light-Grey_Studio_01_720x.jpg?v=1761824211';


    $('.colorRoll[value="weiß"]').css({
  outline: "1px solid black"
});
$('.colorRoll[value="schwarz"]').css({
  outline: "none"
});
}



}

// ROLL 
document.querySelectorAll(".colorRoll").forEach(el => el.addEventListener("click", colRoll));

function colRoll(e){
  color = $(this).val();
  e.stopPropagation();
  if(!visAero&&!visRoll){
    changeAeroRoll(color);
      appendItem(showRoll.getAttribute("data-"+color),5,1,color);
        appendItem(showAero.getAttribute("data-"+color),4,0,color);

           if($(this).val()=="schwarz"){

                document.querySelector('#aerobut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-AERO-BAG-02_Black_Studio_01_1800x1800.jpg?v=1761824211';

    document.querySelector('#rollbut .prod-pics').src ='https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-ROLL-BAG-02_Black_Studio_01_353af4b6-2928-45fa-b763-c8e3d0699cfb_1800x1800.jpg?v=1768394306';

     document.querySelector('#cardAB .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-AERO-BAG-02_Black_Studio_01_1800x1800.jpg?v=1761824211';
     document.querySelector('#cardRB .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-ROLL-BAG-02_Black_Studio_01_353af4b6-2928-45fa-b763-c8e3d0699cfb_1800x1800.jpg?v=1768394306';

        }else{

              document.querySelector('#aerobut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-AERO-BAG-02_Light-Grey_Studio_01_720x.jpg?v=1761824211';
    document.querySelector('#rollbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-ROLL-BAG-02_Light-Grey_Studio_01_25f5ae8b-e377-4fc1-b997-a29e042a1a21_1800x1800.jpg?v=1768394306';


               document.querySelector('#cardAB .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-AERO-BAG-02_Light-Grey_Studio_01_720x.jpg?v=1761824211';
                document.querySelector('#cardRB .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-ROLL-BAG-02_Light-Grey_Studio_01_25f5ae8b-e377-4fc1-b997-a29e042a1a21_1800x1800.jpg?v=1768394306';


        }

  }else{

    if(visRoll){
      toggleRoll();}
  
  changeRoll($(this).val());
  appendItem(showRoll.getAttribute("data-"+color),5,1,color);
  }
   $(".colorRoll").css({
 "outline": "none"
});

  $(this).css({
  "outline": "1px solid black"
});


if($(this).val()=="schwarz"){
  KonfigTracking.track('Farbe', 'Black');
   if(locale=="de"){
     document.getElementById("colortextAB").innerHTML='<br>Farbe: Black';
document.getElementById("colortextRB").innerHTML='<br>Farbe: Black';
   }else if (locale=="en"){
  document.getElementById("colortextAB").innerHTML='<br>Color: Black';
document.getElementById("colortextRB").innerHTML='<br>Color: Black';
   }else if(locale=="fr"){
      document.getElementById("colortextAB").innerHTML='<br>couler: Black';
document.getElementById("colortextRB").innerHTML='<br>couler: Black';

   }
    document.querySelector('#rollbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-ROLL-BAG-02_Black_Studio_01_353af4b6-2928-45fa-b763-c8e3d0699cfb_1800x1800.jpg?v=1768394306';


        document.querySelector('#cardRB .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-ROLL-BAG-02_Black_Studio_01_353af4b6-2928-45fa-b763-c8e3d0699cfb_1800x1800.jpg?v=1768394306';

$('.colorAero[value="schwarz"]').css({
  outline: "1px solid black"
});
$('.colorAero[value="weiß"]').css({
  outline: "none"
});

}else{
  KonfigTracking.track('Farbe', 'Lightgrey');
if(locale=="de"){
     document.getElementById("colortextAB").innerHTML='<br>Farbe: Lightgrey';
document.getElementById("colortextRB").innerHTML='<br>Farbe: Lightgrey';
   }else if (locale=="en"){
  document.getElementById("colortextAB").innerHTML='<br>Color: Lightgrey';
document.getElementById("colortextRB").innerHTML='<br>Color: Lightgrey';
   }else if(locale=="fr"){
      document.getElementById("colortextAB").innerHTML='<br>couler: Lightgrey';
document.getElementById("colortextRB").innerHTML='<br>couler: Lightgrey';

   }
    document.querySelector('#rollbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-ROLL-BAG-02_Light-Grey_Studio_01_25f5ae8b-e377-4fc1-b997-a29e042a1a21_1800x1800.jpg?v=1768394306';

   
                 document.querySelector('#cardRB .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-ROLL-BAG-02_Light-Grey_Studio_01_25f5ae8b-e377-4fc1-b997-a29e042a1a21_1800x1800.jpg?v=1768394306';


 $('.colorAero[value="weiß"]').css({
  outline: "1px solid black"
});
$('.colorAero[value="schwarz"]').css({
  outline: "none"
});
}

}




/*
var rollCol = document.getElementById("rollcol")
rollCol.addEventListener("change",colRoll);



*/

// Cart Function

var items=[]; 



var cart = document.getElementById("addCart1");
//cart.addEventListener("click",addItems1);
cart.addEventListener("click",checkAv);
//variantId = 43629339181321;

/*
async function addItems1(variantId) {
    fetch("/cart/add", {
        method: "post",
        
        body: JSON.stringify({
            id: variantId,
            quantity: 1
        })
    })
}
*/

var allAv = false;

function checkAv(){
  var allAv = true;
  //console.log(availability);
   console.log(productAvailability);
  for (var i = 0; i < 16; i +=1){
    indav= availability[i]
    if(indav !== null && indav !== undefined) {
  console.log(indav);
    //console.log(productAvailability[indav].full_name + productAvailability[indav].variants[col].available);
    if(!productAvailability[indav].variants[col].available) {
      allAv = false;
       KonfigTracking.track('failedcart', 'failedcart', price);
  //alert(productAvailability[indav].full_name + " ist in "+ color + " aktuell nicht erhältlich!");
    //console.log(formData.items[i].col);
    //console.log(formData.items[availability[i]]);
  if(locale=="fr"){
              document.getElementById('hinweis').innerHTML +=  productAvailability[indav].full_name + " en "+ formData.items[i].col ;
      }else{      document.getElementById('hinweis').innerHTML +=  productAvailability[indav].full_name + " in "+ formData.items[i].col ;}  
       document.getElementById('popup').style.display="block";
}}
}
   if(locale=="de"){
document.getElementById('hinweis').innerHTML +=  ", aktuell nicht verfügbar." ;
   }else if (locale=="en"){
document.getElementById('hinweis').innerHTML +=  " is currently not available." ;
   }else if(locale=="fr"){
     document.getElementById('hinweis').innerHTML +=  " n’est actuellement pas disponible" ;

   }
  
  if(allAv){console.log("allav Available");addItems1();
     KonfigTracking.track('addcart', 'addcart', price);
  }

  
} 


document.getElementById('closePop').addEventListener("click", closePopUp);

function closePopUp(){
   document.getElementById('hinweis').innerHTML = "Leider ist "; 
     //document.getElementById('model').style.display="block";
       document.getElementById('popup').style.display="none";
  
}

let formData ={
  'items': [ ]
 };



//New Button Logic

var color= "weiß";
var colorpopup ="lightgrey";

document.querySelectorAll(".colorRSet").forEach(el => el.addEventListener("click", changeColorsRS));

//document.getElementById("colorpickb").addEventListener("click",changeColorsRS);
//document.getElementById("colorpickw").addEventListener("click",changeColors);

function changeColorsRS(e){
  e.stopPropagation(); 
  
   color = $(this).val();

   
   if(!raceSet){
    toggleRaceSet();
   } 
   
  col = $(this).attr("data-c");

  changeSaddlebagSmall(color);
  changeFramebag(color);
 changeAero(color); 
 changeToptube(color);

   $('.colorRSet').css({
  "outline": "none"
});

   $(this).css({
  "outline": "1px solid black"
});

 if($(this).val()=="schwarz"){

      document.querySelector('#rSetbut .prod-pics').src = 'https://cyclite.cc/cdn/shop/files/CYCLITE_RACE-SET_on-bike_black_Studio_01.jpg?v=1770799627&width=800';
KonfigTracking.track('Farbe', 'Black');
  if(locale=="de"){
     document.getElementById("colortextRSet").innerHTML='<br>Farbe: Black';
 document.getElementById("colortextTSet").innerHTML='<br>Farbe: Black';
 document.getElementById("colortextAB").innerHTML='<br>Farbe: Black';
 document.getElementById("colortextTT").innerHTML='<br>Farbe: Black';
 document.getElementById("colortextSBs").innerHTML='<br>Farbe: Black';
 document.getElementById("colortextFB").innerHTML='<br>Farbe: Black';
   }else if (locale=="en"){
 document.getElementById("colortextRSet").innerHTML='<br>Color: Black';
 document.getElementById("colortextTSet").innerHTML='<br>Color: Black';
 document.getElementById("colortextAB").innerHTML='<br>Color: Black';
 document.getElementById("colortextTT").innerHTML='<br>Color: Black';
 document.getElementById("colortextSBs").innerHTML='<br>Color: Black';
 document.getElementById("colortextFB").innerHTML='<br>Color: Black';
   }else if(locale=="fr"){
     document.getElementById("colortextRSet").innerHTML='<br>couler: Black';
 document.getElementById("colortextTSet").innerHTML='<br>couler: Black';
 document.getElementById("colortextAB").innerHTML='<br>couler: Black';
 document.getElementById("colortextTT").innerHTML='<br>couler: Black';
 document.getElementById("colortextSBs").innerHTML='<br>couler: Black';
 document.getElementById("colortextFB").innerHTML='<br>couler: Black';

   }

               document.querySelector('#aerobut .prod-pics').src =  'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-AERO-BAG-02_Black_Studio_01_1800x1800.jpg?v=1761824211';
     document.querySelector('#cardAB .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-AERO-BAG-02_Black_Studio_01_1800x1800.jpg?v=1761824211';
 
           document.querySelector('#toptubebut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_TOP-TUBE-BAG-03_Black_Studio_01_4fdc2dc2-fa6a-4d3d-9478-2fadf600d134_1800x1800.jpg?v=1761738584';
    document.querySelector('#cardTT .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_TOP-TUBE-BAG-03_Black_Studio_01_4fdc2dc2-fa6a-4d3d-9478-2fadf600d134_1800x1800.jpg?v=1761738584';


      document.querySelector('#saddlebagsbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_SADDLE-BAG-SMALL-02_Black_Studio_01_1800x1800.jpg?v=1761827654';
   document.querySelector('#cardSBS .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_SADDLE-BAG-SMALL-02_Black_Studio_01_1800x1800.jpg?v=1761827654';

     document.querySelector('#framebagbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FRAME-BAG-03_Black_Studio_01_720x.jpg?v=1765864945';
   document.querySelector('#cardFB .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FRAME-BAG-03_Black_Studio_01_720x.jpg?v=1765864945';


$('.colorAero[value="schwarz"]').css({
  outline: "1px solid black"
});

$('.colorToptube[value="schwarz"]').css({
  outline: "1px solid black"
});

$('.colorSaddleS[value="schwarz"]').css({
  outline: "1px solid black"
});

$('.colorFB[value="schwarz"]').css({
  outline: "1px solid black"
});

  $('.colorTSet[value="schwarz"]').css({
  "outline": "1px solid black"
});

$('.colorAero[value="weiß"]').css({
   "outline": "none"
});

$('.colorToptube[value="weiß"]').css({
   "outline": "none"
});

$('.colorSaddleS[value="weiß"]').css({
   "outline": "none"
});

$('.colorFB[value="weiß"]').css({
   "outline": "none"
});

 $('.colorTSet[value="weiß"]').css({
   "outline": "none"
});




}else{

      document.querySelector('#rSetbut .prod-pics').src = 'https://cyclite.cc/cdn/shop/files/CYCLITE_RACE-SET_on-bike_light-grey_Studio_01.jpg?v=1768352732&width=800';

  KonfigTracking.track('Farbe', 'Lightgrey');
   if(locale=="de"){
     document.getElementById("colortextRSet").innerHTML='<br>Farbe: Lightgrey';
 document.getElementById("colortextTSet").innerHTML='<br>Farbe: Lightgrey';
 document.getElementById("colortextAB").innerHTML='<br>Farbe: Lightgrey';
 document.getElementById("colortextTT").innerHTML='<br>Farbe: Lightgrey';
 document.getElementById("colortextSBs").innerHTML='<br>Farbe: Lightgrey';
 document.getElementById("colortextFB").innerHTML='<br>Farbe: Lightgrey';
   }else if (locale=="en"){
 document.getElementById("colortextRSet").innerHTML='<br>Color: Lightgrey';
 document.getElementById("colortextTSet").innerHTML='<br>Color: Lightgrey';
 document.getElementById("colortextAB").innerHTML='<br>Color: Lightgrey';
 document.getElementById("colortextTT").innerHTML='<br>Color: Lightgrey';
 document.getElementById("colortextSBs").innerHTML='<br>Color: Lightgrey';
 document.getElementById("colortextFB").innerHTML='<br>Color: Lightgrey';
   }else if(locale=="fr"){
     document.getElementById("colortextRSet").innerHTML='<br>couler: Lightgrey';
 document.getElementById("colortextTSet").innerHTML='<br>couler: Lightgrey';
 document.getElementById("colortextAB").innerHTML='<br>couler: Lightgrey';
 document.getElementById("colortextTT").innerHTML='<br>couler: Lightgrey';
 document.getElementById("colortextSBs").innerHTML='<br>couler: Lightgrey';
 document.getElementById("colortextFB").innerHTML='<br>couler: Lightgrey';

   }

   
                 document.querySelector('#aerobut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-AERO-BAG-02_Light-Grey_Studio_01_720x.jpg?v=1761824211';
               document.querySelector('#cardAB .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-AERO-BAG-02_Light-Grey_Studio_01_720x.jpg?v=1761824211';


         document.querySelector('#toptubebut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_TOP-TUBE-BAG-03_Light-Grey_Studio_01_88bcc662-44c0-4558-9363-beed1327eb9c_1800x1800.jpg?v=1761738584';
  document.querySelector('#cardTT .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_TOP-TUBE-BAG-03_Light-Grey_Studio_01_88bcc662-44c0-4558-9363-beed1327eb9c_1800x1800.jpg?v=1761738584';



document.querySelector('#saddlebagsbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_SADDLE-BAG-SMALL-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761827654';
 document.querySelector('#cardSBS .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_SADDLE-BAG-SMALL-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761827654';


        document.querySelector('#framebagbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FRAME-BAG-03_Light_grey_Studio_01_1800x1800.jpg?v=1765864945';
 document.querySelector('#cardFB .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FRAME-BAG-03_Light_grey_Studio_01_1800x1800.jpg?v=1765864945';


$('.colorAero[value="weiß"]').css({
  outline: "1px solid black"
});

$('.colorToptube[value="weiß"]').css({
  outline: "1px solid black"
});

$('.colorSaddleS[value="weiß"]').css({
  outline: "1px solid black"
});

$('.colorFB[value="weiß"]').css({
  outline: "1px solid black"
});

 $('.colorTSet[value="weiß"]').css({
  "outline": "1px solid black"
});

$('.colorAero[value="schwarz"]').css({
  "outline": "none"
});

$('.colorToptube[value="schwarz"]').css({
   "outline": "none"
});

$('.colorSaddleS[value="schwarz"]').css({
 "outline": "none"
});

$('.colorFB[value="schwarz"]').css({
  "outline": "none"
});

  $('.colorTSet[value="schwarz"]').css({
   "outline": "none"
});
}

}




document.querySelectorAll(".colorTSet").forEach(el => el.addEventListener("click", changeColorsTS));

//document.getElementById("colorpickb").addEventListener("click",changeColorsRS);
//document.getElementById("colorpickw").addEventListener("click",changeColors);

function changeColorsTS(e){
  e.stopPropagation(); 
  
   color = $(this).val();
   
 if(!touringSet){
    toggleTouringSet();

   } 
   

  col = $(this).attr("data-c");

  changeSaddlebag(color);
  changeFramebagl(color);
 changeAeroRoll(color); 
 changeToptubel(color);
 changepouch(color);
  changepouchL(color);


   $('.colorTSet').css({
  "outline": "none"
});

   $(this).css({
  "outline": "1px solid black"
});

 if($(this).val()=="schwarz"){

    document.querySelector('#tSetbut .prod-pics').src = 'https://cyclite.cc/cdn/shop/files/CYCLITE_RACE-SET_on-bike_black_Studio_01.jpg?v=1770799627&width=1000';

KonfigTracking.track('Farbe', 'Black');
   if(locale=="de"){
   document.getElementById("colortextRSet").innerHTML='<br>Farbe: Black';
 document.getElementById("colortextTSet").innerHTML='<br>Farbe: Black';
 
 document.getElementById("colortextTTL").innerHTML='<br>Farbe: Black';
 document.getElementById("colortextSB").innerHTML='<br>Farbe: Black';
 document.getElementById("colortextFBL").innerHTML='<br>Farbe: Black';
  document.getElementById("colortextAB").innerHTML='<br>Farbe: Black';
   document.getElementById("colortextRB").innerHTML='<br>Farbe: Black';
    document.getElementById("colortextFP").innerHTML='<br>Farbe: Black';

   }else if (locale=="en"){
 document.getElementById("colortextRSet").innerHTML='<br>Color: Black';
 document.getElementById("colortextTSet").innerHTML='<br>Color: Black';
 
 document.getElementById("colortextTTL").innerHTML='<br>Color: Black';
 document.getElementById("colortextSB").innerHTML='<br>Color: Black';
 document.getElementById("colortextFBL").innerHTML='<br>Color: Black';
  document.getElementById("colortextAB").innerHTML='<br>Color: Black';
   document.getElementById("colortextRB").innerHTML='<br>Color: Black';
    document.getElementById("colortextFP").innerHTML='<br>Color: Black';

   }else if(locale=="fr"){
    document.getElementById("colortextRSet").innerHTML='<br>coleur: Black';
 document.getElementById("colortextTSet").innerHTML='<br>coleur: Black';
 
 document.getElementById("colortextTTL").innerHTML='<br>coleur: Black';
 document.getElementById("colortextSB").innerHTML='<br>coleur: Black';
 document.getElementById("colortextFBL").innerHTML='<br>coleur: Black';
  document.getElementById("colortextAB").innerHTML='<br>coleur: Black';
   document.getElementById("colortextRB").innerHTML='<br>coleur: Black';
    document.getElementById("colortextFP").innerHTML='<br>coleur: Black';


   }

    document.querySelector('#toptubelbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_TOP-TUBE-BAG-LARGE-02_Black_Studio_01_1800x1800.jpg?v=1761737969';
     document.querySelector('#cardTTL .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_TOP-TUBE-BAG-LARGE-02_Black_Studio_01_1800x1800.jpg?v=1761737969';


  document.querySelector('#saddlebagbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_SADDLE-BAG-02_Black_Studio_01_1800x1800.jpg?v=1761739753';
   document.querySelector('#cardSB .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_SADDLE-BAG-02_Black_Studio_01_1800x1800.jpg?v=1761739753';

     document.querySelector('#framebaglbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FRAME-BAG-LARGE-02_Black_Studo_01_1800x1800.jpg?v=1761737018';
 document.querySelector('#cardFBL .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FRAME-BAG-LARGE-02_Black_Studo_01_1800x1800.jpg?v=1761737018';
    
 document.querySelector('#aerobut .prod-pics').src =  'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-AERO-BAG-02_Black_Studio_01_1800x1800.jpg?v=1761824211';
     document.querySelector('#cardAB .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-AERO-BAG-02_Black_Studio_01_1800x1800.jpg?v=1761824211';

     document.querySelector('#rollbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-ROLL-BAG-02_Black_Studio_01_353af4b6-2928-45fa-b763-c8e3d0699cfb_1800x1800.jpg?v=1768394306';
        document.querySelector('#cardRB .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-ROLL-BAG-02_Black_Studio_01_353af4b6-2928-45fa-b763-c8e3d0699cfb_1800x1800.jpg?v=1768394306';
                      
        document.querySelector('#foodpouchbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FOOD-POUCH-02_Black_Studio_01_1800x1800.jpg?v=1761825503';
               document.querySelector('#cardFP .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FOOD-POUCH-02_Black_Studio_01_1800x1800.jpg?v=1761825503';
               document.querySelector('#cardFPL .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FOOD-POUCH-02_Black_Studio_01_1800x1800.jpg?v=1761825503';


    
   

$('.colorAero[value="schwarz"]').css({
  outline:  "1px solid black"
});

$('.colorRoll[value="schwarz"]').css({
  outline:  "1px solid black"
});

$('.colorToptubeL[value="schwarz"]').css({
  outline:  "1px solid black"
});

$('.colorSaddle[value="schwarz"]').css({
  outline:  "1px solid black"
});

$('.colorFBL[value="schwarz"]').css({
  outline:  "1px solid black"
});

$('.colorFP[value="schwarz"]').css({
  "outline":  "1px solid black"
});


 $('.colorRSet[value="schwarz"]').css({
  "outline":  "1px solid black"
});




$('.colorAero[value="weiß"]').css({
  outline: "none"
});

$('.colorRoll[value="weiß"]').css({
  outline: "none"
});

$('.colorToptubeL[value="weiß"]').css({
  outline: "none"
});

$('.colorSaddle[value="weiß"]').css({
  outline: "none"
});

$('.colorFBL[value="weiß"]').css({
  outline:"none"
});

$('.colorFP[value="weiß"]').css({
  "outline": "none"
});


 $('.colorRSet[value="weiß"]').css({
  "outline": "none"
});

}else{
    document.querySelector('#tSetbut .prod-pics').src = 'https://cyclite.cc/cdn/shop/files/CYCLITE_TOURING-SET_on-bike_light-grey_Studio_01.jpg?v=1768569376&width=1000';
KonfigTracking.track('Farbe', 'Lightgrey');

   if(locale=="de"){
   document.getElementById("colortextRSet").innerHTML='<br>Farbe: Lightgrey';
 document.getElementById("colortextTSet").innerHTML='<br>Farbe: Lightgrey';
 
 document.getElementById("colortextTTL").innerHTML='<br>Farbe: Lightgrey';
 document.getElementById("colortextSB").innerHTML='<br>Farbe: Lightgrey';
 document.getElementById("colortextFBL").innerHTML='<br>Farbe: Lightgrey';
  document.getElementById("colortextAB").innerHTML='<br>Farbe: Lightgrey';
   document.getElementById("colortextRB").innerHTML='<br>Farbe: Lightgrey';
    document.getElementById("colortextFP").innerHTML='<br>Farbe: Lightgrey';

   }else if (locale=="en"){
 document.getElementById("colortextRSet").innerHTML='<br>Color: Lightgrey';
 document.getElementById("colortextTSet").innerHTML='<br>Color: Lightgrey';
 
 document.getElementById("colortextTTL").innerHTML='<br>Color: Lightgrey';
 document.getElementById("colortextSB").innerHTML='<br>Color: Lightgrey';
 document.getElementById("colortextFBL").innerHTML='<br>Color: Lightgrey';
  document.getElementById("colortextAB").innerHTML='<br>Color: Lightgrey';
   document.getElementById("colortextRB").innerHTML='<br>Color: Lightgrey';
    document.getElementById("colortextFP").innerHTML='<br>Color: Lightgrey';

   }else if(locale=="fr"){
    document.getElementById("colortextRSet").innerHTML='<br>coleur: Lightgrey';
 document.getElementById("colortextTSet").innerHTML='<br>coleur: Lightgrey';
 
 document.getElementById("colortextTTL").innerHTML='<br>coleur: Lightgrey';
 document.getElementById("colortextSB").innerHTML='<br>coleur: Lightgrey';
 document.getElementById("colortextFBL").innerHTML='<br>coleur: Lightgrey';
  document.getElementById("colortextAB").innerHTML='<br>coleur: Lightgrey';
   document.getElementById("colortextRB").innerHTML='<br>coleur: Lightgrey';
    document.getElementById("colortextFP").innerHTML='<br>coleur: Lightgrey';


   }

     document.querySelector('#toptubelbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_TOP-TUBE-BAG-LARGE-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761737969';
   document.querySelector('#cardTTL .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_TOP-TUBE-BAG-LARGE-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761737969';

   document.querySelector('#saddlebagbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_SADDLE-BAG-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761739753';
 document.querySelector('#cardSB .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_SADDLE-BAG-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761739753';

   document.querySelector('#framebaglbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FRAME-BAG-LARGE-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761737018';
 document.querySelector('#cardFBL .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FRAME-BAG-LARGE-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761737018';

       document.querySelector('#aerobut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-AERO-BAG-02_Light-Grey_Studio_01_720x.jpg?v=1761824211';
        document.querySelector('#cardAB .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-AERO-BAG-02_Light-Grey_Studio_01_720x.jpg?v=1761824211';

          document.querySelector('#rollbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-ROLL-BAG-02_Light-Grey_Studio_01_25f5ae8b-e377-4fc1-b997-a29e042a1a21_1800x1800.jpg?v=1768394306';
          document.querySelector('#cardRB .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_HANDLE-BAR-ROLL-BAG-02_Light-Grey_Studio_01_25f5ae8b-e377-4fc1-b997-a29e042a1a21_1800x1800.jpg?v=1768394306';

          document.querySelector('#foodpouchbut .prod-pics').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FOOD-POUCH-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761825503';

                       document.querySelector('#cardFPL .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FOOD-POUCH-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761825503';
             document.querySelector('#cardFP .imgCard').src = 'https://z49xocd6o3t1z59q-52906557613.shopifypreview.com/cdn/shop/files/CYCLITE_FOOD-POUCH-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761825503';


$('.colorAero[value="weiß"]').css({
  outline: "1px solid black"
});

$('.colorRoll[value="weiß"]').css({
  outline: "1px solid black"
});

$('.colorToptubeL[value="weiß"]').css({
  outline: "1px solid black"
});

$('.colorSaddle[value="weiß"]').css({
  outline: "1px solid black"
});

$('.colorFBL[value="weiß"]').css({
  outline: "1px solid black"
});

$('.colorFP[value="weiß"]').css({
  "outline": "1px solid black"
});


 $('.colorRSet[value="weiß"]').css({
  "outline": "1px solid black"
});




$('.colorAero[value="schwarz"]').css({
  outline: "none"
});

$('.colorRoll[value="schwarz"]').css({
  outline: "none"
});

$('.colorToptubeL[value="schwarz"]').css({
  outline: "none"
});

$('.colorSaddle[value="schwarz"]').css({
  outline: "none"
});

$('.colorFBL[value="schwarz"]').css({
  outline: "none"
});

$('.colorFP[value="schwarz"]').css({
  "outline": "none"
});


 $('.colorRSet[value="schwarz"]').css({
  "outline": "none"
});
}

}
 
// UI Geschichten

const elements = document.querySelectorAll('.toggleUI');

elements.forEach(element => {
    console.log("added");
  element.addEventListener('click', switchUI);
    // hier kommt dein Code, z.B. etwas verändern
  });


function switchUI() {
console.log("click");
     $(".panelUI").css({
       "display":"none"
      });

            $('.toggleUI').css({
        "background":"white"
      })

      $(this).css({
        "background":"#f3f3f3"
      })
  
      v = $(this).attr('value');
      console.log(v);
 $("#"+v).css({
       "display":"grid"
      });
}

   



  var showRSet = document.getElementById("rSetbut");
            showRSet.addEventListener("click",toggleRaceSet);


      
var raceSet = false;

        function toggleRaceSet(){
        

           if(touringSet){
            toggleTouringSet();
          }

          if(raceSet){
showRSet.style.border="3px solid  #e3e3e3";
           


 if(!visAero){
        toggleAero();}

        if(!visSaddleSmall){
      
        toggleSaddleSmallMain();}
         if(!visFramebag){

        toggleframebagMain();
       }

         if(!visTopTube){
        toggleToptubeMain();
       }

}else{
showRSet.style.border="3px solid black";
  KonfigTracking.track('Set', 'RACE SET');
 if(visAero){
        toggleAero(true);}

        if(visSaddleSmall){
      
        toggleSaddleSmallMain(true);}
         if(visFramebag){

        toggleframebagMain(true);
       }

         if(visTopTube){
        toggleToptubeMain(true);
       }


          }


        raceSet = !raceSet;

        }


            var showTSet = document.getElementById("tSetbut");
showTSet.addEventListener("click",toggleTouringSet);


      
var touringSet = false;

        function toggleTouringSet(){

 if(raceSet){
            toggleRaceSet();
          }

          if(touringSet){
showTSet.style.border="3px solid  #e3e3e3";
      if(!visSaddlebag){
        toggleSaddleMain();}

         if(!visFramebagl){
        toggleframebaglMain();
         }
         if(!visTopTubel){
        toggleToptubel();
         }
          if(!visFoodpouch){
        toggleFoodpouch();
          }
          if(!visFoodpouchL){
        toggleFoodpouchL();
          }

          if(!visAero && !visRoll){
        removeItem(4);
        removeItem(5);

        disposeAeroRoll();
        
        subStats(showAero.getAttribute("data-vol"),showAero.getAttribute("data-price"),showAero.getAttribute("data-weight"));
        showAero.style.border="1px solid lightgrey";
        visAero = !visAero;

    subStats(showRoll.getAttribute("data-vol"),showRoll.getAttribute("data-price"),showRoll.getAttribute("data-weight"));
    visRoll = !visRoll;
    showRoll.style.border="1px solid lightgrey";

        document.querySelector("#cardRB").remove();
         document.querySelector("#cardAB").remove();

}

          }else{
showTSet.style.border="3px solid black";
  KonfigTracking.track('Set', 'TOURING SET');
 if(visSaddlebag){
        toggleSaddleMain(true);}

         if(visFramebagl){
        toggleframebaglMain(true);
         }
         if(visTopTubel){
        toggleToptubel(true);
         }
          if(visFoodpouch){
        toggleFoodpouch(null, true);
          }
  if(visFoodpouchL){
        toggleFoodpouchL(null, true);
          }
              
          if(!visAero){
            disposeAero();
         document.querySelector("#cardAB").remove();
            subStats(showAero.getAttribute("data-vol"),showAero.getAttribute("data-price"),showAero.getAttribute("data-weight"));

          }

           if(!visRoll){
            disposeRoll();
              document.querySelector("#cardRB").remove();
              subStats(showRoll.getAttribute("data-vol"),showRoll.getAttribute("data-price"),showRoll.getAttribute("data-weight"));
          }


          //add Aeroroll
        appendItem(showRoll.getAttribute("data-"+color),5,1,color);
        appendItem(showAero.getAttribute("data-"+color),4,0,color);

        renderAeroRoll();
        
        addStats(showAero.getAttribute("data-vol"),showAero.getAttribute("data-price"),showAero.getAttribute("data-weight"));
        showAero.style.border="3px solid black";
        visAero = !visAero;

    addStats(showRoll.getAttribute("data-vol"),showRoll.getAttribute("data-price"),showRoll.getAttribute("data-weight"));
    visRoll = !visRoll;
    showRoll.style.border="3px solid black";

     document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardAB">
      <button id="closeAB" class="closecard">-</button>
      <img class="imgCard" src="https://cyclite.cc/cdn/shop/files/CYCLITE_HANDLE-BAR-AERO-BAG-02_Light-Grey_Studio_01_1800x1800.jpg?v=1761824211">
      <p style="text-align:center;font-weight:bold;font-size:12px;">AERO BAG</p>
    </div>
  `);

  document.getElementById("closeAB")
document.getElementById("closeAB").addEventListener("click", toggleAero);

    document.getElementById("cardcontainer")
  .insertAdjacentHTML("beforeend", `
    <div class="itemcard" id="cardRB">
      <button id="closeRB" class="closecard">-</button>
      <img class="imgCard" src="https://cyclite.cc/cdn/shop/files/CYCLITE_HANDLE-BAR-ROLL-BAG-02_Light-Grey_Studio_01_25f5ae8b-e377-4fc1-b997-a29e042a1a21_1800x1800.jpg?v=1768394306">
      <p style="text-align:center;font-weight:bold;font-size:12px;">ROLL BAG</p>
    </div>
  `);
document.getElementById("closeRB")
document.getElementById("closeRB").addEventListener("click", toggleRoll);




          }


       
       
        
//add Aeroroll

        touringSet = !touringSet;

        }